package com.schoolconnect.app.datasource.network

import com.schoolconnect.app.datasource.network.request.RequestOtpRequest
import com.schoolconnect.app.datasource.network.request.AcademicYearCreateRequest
import com.schoolconnect.app.datasource.network.request.QuickMarkRequest
import com.schoolconnect.app.datasource.network.request.AttendanceUpdateRequest
import com.schoolconnect.app.datasource.network.request.AttendanceRecordRequest
import com.schoolconnect.app.datasource.network.request.AcademicYearUpdateRequest
import com.schoolconnect.app.datasource.network.request.AcademicYearToggleActiveRequest
import com.schoolconnect.app.datasource.network.request.ClassSectionCreateRequest
import com.schoolconnect.app.datasource.network.request.ClassSectionWithSubjectsCreateRequest
import com.schoolconnect.app.datasource.network.request.ClassSectionFilterRequest
import com.schoolconnect.app.datasource.network.request.ClassSectionUpdateRequest
import com.schoolconnect.app.datasource.network.request.ParentFilterRequest
import com.schoolconnect.app.datasource.network.request.StudentFilterRequest
import com.schoolconnect.app.datasource.network.request.SchoolStaffFilterRequest
import com.schoolconnect.app.datasource.network.request.ClassSubjectLinkCreateRequest
import com.schoolconnect.app.datasource.network.request.ClassSubjectLinkUpdateRequest
import com.schoolconnect.app.datasource.network.request.SchoolCreateRequest
import com.schoolconnect.app.datasource.network.request.SchoolUpdateRequest
import com.schoolconnect.app.datasource.network.request.SchoolToggleStatusRequest
import com.schoolconnect.app.datasource.network.request.SubjectCreateRequest
import com.schoolconnect.app.datasource.network.request.SubjectFilterRequest
import com.schoolconnect.app.datasource.network.request.SubjectUpdateRequest
import com.schoolconnect.app.datasource.network.request.UserCreateRequest
import com.schoolconnect.app.datasource.network.request.UserSchoolRoleUpdateRequest
import com.schoolconnect.app.datasource.network.request.UserToggleStatusRequest
import com.schoolconnect.app.datasource.network.request.UserUpdateRequest
import com.schoolconnect.app.datasource.network.request.StudentWithSubjectEnrollmentsCreateRequest
import com.schoolconnect.app.datasource.network.request.StudentUpdateRequest
import com.schoolconnect.app.datasource.network.request.StudentToggleStatusRequest
import com.schoolconnect.app.datasource.network.request.StudentSubjectEnrollmentCreateRequest
import com.schoolconnect.app.datasource.network.request.StudentParentWrapperCreateRequest
import com.schoolconnect.app.datasource.network.request.ParentCreateRequest
import com.schoolconnect.app.datasource.network.request.ParentUpdateRequest
import com.schoolconnect.app.datasource.network.request.StudentParentLinkCreateRequest
import com.schoolconnect.app.datasource.network.request.StudentParentLinkUpdateRequest
import com.schoolconnect.app.datasource.network.request.SchoolStaffCreateRequest
import com.schoolconnect.app.datasource.network.request.AddStaffWithAssignmentsRequest
import com.schoolconnect.app.datasource.network.request.UpdateStaffWithAssignmentsRequest
import com.schoolconnect.app.datasource.network.request.SchoolStaffUpdateRequest
import com.schoolconnect.app.datasource.network.request.AppStaffUpdateRequest
import com.schoolconnect.app.datasource.network.request.VerifyOtpRequest
import com.schoolconnect.app.datasource.network.request.FileUploadRequest
import com.schoolconnect.app.datasource.network.request.HomeworkCreateRequest
import com.schoolconnect.app.datasource.network.request.HomeworkUpdateRequest
import com.schoolconnect.app.datasource.network.request.ExamCreateRequest
import com.schoolconnect.app.datasource.network.request.ExamUpdateRequest
import com.schoolconnect.app.datasource.network.request.ExamResultBulkEntryRequest
import com.schoolconnect.app.datasource.network.request.NoticeCreateRequest
import com.schoolconnect.app.datasource.network.request.NoticeUpdateRequest
import com.schoolconnect.app.datasource.network.request.EventCreateRequest
import com.schoolconnect.app.datasource.network.request.EventUpdateRequest
import com.schoolconnect.app.datasource.network.request.ParentNoteCreateRequest
import com.schoolconnect.app.datasource.network.request.ParentNoteUpdateRequest
import com.schoolconnect.app.datasource.network.request.ParentNoteReplyCreateRequest
import com.schoolconnect.app.datasource.network.request.ClassConversationCreateRequest
import com.schoolconnect.app.datasource.network.request.ClassConversationUpdateRequest
import com.schoolconnect.app.datasource.network.request.ClassConversationReplyCreateRequest
import com.schoolconnect.app.datasource.network.request.ClassConversationModerationActionRequest
import com.schoolconnect.app.datasource.network.request.CalendarEventCreateRequest
import com.schoolconnect.app.datasource.network.request.CalendarEventBulkCreateRequest
import com.schoolconnect.app.datasource.network.request.CalendarEventUpdateRequest
import com.schoolconnect.app.datasource.network.request.CalendarImportCommitRequest
import com.schoolconnect.app.datasource.network.request.SchoolWeeklyHolidayConfigCreateRequest
import com.schoolconnect.app.datasource.network.request.SchoolConfigGeneralUpdateRequest
import com.schoolconnect.app.datasource.network.request.SchoolConfigCalendarUpdateRequest
import com.schoolconnect.app.datasource.network.request.SchoolConfigFeatureUpdateRequest
import com.schoolconnect.app.datasource.network.request.DocumentCreateRequest
import com.schoolconnect.app.datasource.network.request.DocumentUpdateRequest
import com.schoolconnect.app.datasource.network.response.DashboardAnalyticsResponse
import com.schoolconnect.app.datasource.network.response.DashboardStatisticsResponse
import com.schoolconnect.app.datasource.network.response.EventsNoticesAnalyticsResponse
import com.schoolconnect.app.datasource.network.response.AcademicYearAnalyticsResponse
import com.schoolconnect.app.datasource.network.response.AcademicYearResponse
import com.schoolconnect.app.datasource.network.response.AcademicYearWithSchoolResponse
import com.schoolconnect.app.datasource.network.response.UsageAdoptionReportResponse
import com.schoolconnect.app.datasource.network.response.AttendanceReportResponse
import com.schoolconnect.app.datasource.network.response.AcademicPerformanceReportResponse
import com.schoolconnect.app.datasource.network.response.CombinedPerformanceReportResponse
import com.schoolconnect.app.datasource.network.response.BulkUploadResponse
import com.schoolconnect.app.datasource.network.response.BulkUploadValidationResponse
import com.schoolconnect.app.datasource.network.response.StudentEnrollmentBulkResponse
import com.schoolconnect.app.datasource.network.response.StudentEnrollmentValidationResponse
import com.schoolconnect.app.datasource.network.response.ClassSectionResponse
import com.schoolconnect.app.datasource.network.response.ClassSubjectLinkResponse
import com.schoolconnect.app.datasource.network.response.ITUsersAnalyticsResponse
import com.schoolconnect.app.datasource.network.response.ParentListResponse
import com.schoolconnect.app.datasource.network.response.ParentDashboardResponse
import com.schoolconnect.app.datasource.network.response.ParentEventListItemResponse
import com.schoolconnect.app.datasource.network.response.ParentResponse
import com.schoolconnect.app.datasource.network.response.SchoolAnalyticsResponse
import com.schoolconnect.app.datasource.network.response.SchoolConfigListItemResponse
import com.schoolconnect.app.datasource.network.response.SchoolConfigurationResponse
import com.schoolconnect.app.datasource.network.response.SchoolWeeklyHolidayConfigResponse
import com.schoolconnect.app.datasource.network.response.HolidayImportResponse
import com.schoolconnect.app.datasource.network.response.CalendarEventPublicResponse
import com.schoolconnect.app.datasource.network.response.CalendarEventAdminResponse
import com.schoolconnect.app.datasource.network.response.CalendarImportValidationResponse
import com.schoolconnect.app.datasource.network.response.CalendarImportCommitResponse
import com.schoolconnect.app.datasource.network.response.TicketListItemResponse
import com.schoolconnect.app.datasource.network.response.TicketResponse
import com.schoolconnect.app.datasource.network.response.SupportTicketStatisticsResponse
import com.schoolconnect.app.datasource.network.response.SchoolUsersAnalyticsResponse
import com.schoolconnect.app.datasource.network.response.StudentResponse
import com.schoolconnect.app.datasource.network.response.StudentListResponse
import com.schoolconnect.app.datasource.network.response.StudentParentLinkResponse
import com.schoolconnect.app.datasource.network.response.StudentSubjectEnrollmentResponse
import com.schoolconnect.app.datasource.network.response.SchoolStaffResponse
import com.schoolconnect.app.datasource.network.response.SchoolStaffWithAssignmentsResponse
import com.schoolconnect.app.datasource.network.response.RequestOtpResponse
import com.schoolconnect.app.datasource.network.response.PlatformUsersResponse
import com.schoolconnect.app.datasource.network.response.RecordListResponse
import com.schoolconnect.app.datasource.network.response.RecordListItems
import com.schoolconnect.app.datasource.network.response.TimetableClassHeaderResponse
import com.schoolconnect.app.datasource.network.response.ParentTimetableWeekResponse
import com.schoolconnect.app.datasource.network.response.TeacherTimetableClassResponse
import com.schoolconnect.app.datasource.network.response.WeeklyTimetableResponse
import com.schoolconnect.app.datasource.network.response.TimetableViewResponse
import com.schoolconnect.app.datasource.network.request.TimetableCombinedCreateRequest
import com.schoolconnect.app.datasource.network.request.TimetableCombinedUpdateRequest
import com.schoolconnect.app.datasource.network.response.RoleResponse
import com.schoolconnect.app.datasource.network.response.RecentActivitiesResponse
import com.schoolconnect.app.datasource.network.response.SchoolResponse
import com.schoolconnect.app.datasource.network.response.SchoolStatisticsResponse
import com.schoolconnect.app.datasource.network.response.UserRoleAuthorizationsResponse
import com.schoolconnect.app.datasource.network.response.SystemHealthResponse
import com.schoolconnect.app.datasource.network.response.LookupCategoryResponse
import com.schoolconnect.app.datasource.network.response.LookupItemResponse
import com.schoolconnect.app.datasource.network.response.TeacherDashboardOverviewResponse
import com.schoolconnect.app.datasource.network.response.TeacherStatisticsResponse
import com.schoolconnect.app.datasource.network.response.TeacherStudentListResponse
import com.schoolconnect.app.datasource.network.response.TeacherStudentAttendanceStatsResponse
import com.schoolconnect.app.datasource.network.response.TeacherStudentAttendanceRecordsResponse
import com.schoolconnect.app.datasource.network.response.StudentAttendanceResponse
import com.schoolconnect.app.datasource.network.response.QuickMarkDataResponse
import com.schoolconnect.app.datasource.network.response.AttendanceHistoryResponse
import com.schoolconnect.app.datasource.network.response.TeacherAttendanceInsightsResponse
import com.schoolconnect.app.datasource.network.response.AttendanceInsightsResponse
import com.schoolconnect.app.datasource.network.response.TeacherAttendanceStatisticsResponse
import com.schoolconnect.app.datasource.network.response.HomeworkListResponse
import com.schoolconnect.app.datasource.network.response.HomeworkResponse
import com.schoolconnect.app.datasource.network.response.TeacherHomeworkStatisticsResponse
import com.schoolconnect.app.datasource.network.response.NoticeResponse
import com.schoolconnect.app.datasource.network.response.ParentNoticeListItemResponse
import com.schoolconnect.app.datasource.network.response.TeacherNoticeStatisticsResponse
import com.schoolconnect.app.datasource.network.request.UsageAdoptionReportRequest
import com.schoolconnect.app.datasource.network.request.AttendanceReportRequest
import com.schoolconnect.app.datasource.network.request.AcademicPerformanceReportRequest
import com.schoolconnect.app.datasource.network.request.CombinedPerformanceReportRequest
import com.schoolconnect.app.datasource.network.request.QuickAnnouncementCreateRequest
import com.schoolconnect.app.datasource.network.request.QuickAnnouncementUpdateRequest
import com.schoolconnect.app.datasource.network.response.QuickAnnouncementListResponse
import com.schoolconnect.app.datasource.network.response.QuickAnnouncementResponse
import com.schoolconnect.app.datasource.network.response.ParentNoteResponse
import com.schoolconnect.app.datasource.network.response.ParentNoteReplyResponse
import com.schoolconnect.app.datasource.network.response.TeacherParentNoteStatisticsResponse
import com.schoolconnect.app.datasource.network.response.ClassConversationListResponse
import com.schoolconnect.app.datasource.network.response.ClassConversationResponse
import com.schoolconnect.app.datasource.network.response.ClassConversationReplyResponse
import com.schoolconnect.app.datasource.network.response.EventResponse
import com.schoolconnect.app.datasource.network.response.TeacherEventStatisticsResponse
import com.schoolconnect.app.datasource.network.response.serverTotalCountOrNull
import com.schoolconnect.app.datasource.network.response.VerifyOtpResponse
import com.schoolconnect.app.datasource.network.response.AppStaffResponse
import com.schoolconnect.app.datasource.network.response.DashboardSchoolsAnalyticsResponse
import com.schoolconnect.app.datasource.network.response.SubjectResponse
import com.schoolconnect.app.datasource.network.response.ExamResponse
import com.schoolconnect.app.datasource.network.response.TeacherExamStatisticsResponse
import com.schoolconnect.app.datasource.network.response.TeacherExamListResponse
import com.schoolconnect.app.datasource.network.response.TeacherExamResultListResponse
import com.schoolconnect.app.datasource.network.response.ExamResultsListResponse
import com.schoolconnect.app.datasource.network.response.ExamResultsSummaryResponse
import com.schoolconnect.app.datasource.network.response.StudentExamResultRecordsResponse
import com.schoolconnect.app.datasource.network.response.ExamInsightsResponse
import com.schoolconnect.app.datasource.network.response.ExamPublishResponse
import com.schoolconnect.app.datasource.network.response.ExamImportResponse
import com.schoolconnect.app.datasource.network.response.ExamResultBulkEntryResponse
import com.schoolconnect.app.datasource.network.response.FileConfirmResponse
import com.schoolconnect.app.datasource.network.response.FileDownloadUrlResponse
import com.schoolconnect.app.datasource.network.response.FileListResponse
import com.schoolconnect.app.datasource.network.response.FileObjectResponse
import com.schoolconnect.app.datasource.network.response.FileRestoreResponse
import com.schoolconnect.app.datasource.network.response.FileUploadGrant
import com.schoolconnect.app.datasource.network.response.DocumentLibraryListResponse
import com.schoolconnect.app.datasource.network.response.DocumentResponseDTO
import com.schoolconnect.app.runtime.AuthSessionCenter
import com.schoolconnect.app.runtime.AppErrorCenter
import com.schoolconnect.app.util.BuildConfig
import com.schoolconnect.app.util.PlatformType
import com.schoolconnect.app.util.scLog
import com.schoolconnect.app.downloadFile
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.HttpRequestRetry
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logger
import io.ktor.client.plugins.logging.Logging
import io.ktor.client.request.forms.MultiPartFormDataContent
import io.ktor.client.request.forms.FormDataContent
import io.ktor.client.request.forms.formData
import io.ktor.client.request.forms.FormBuilder
import io.ktor.http.ContentDisposition
import io.ktor.http.ContentType
import io.ktor.http.Headers
import io.ktor.client.request.header
import io.ktor.client.request.request
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.http.content.TextContent
import io.ktor.http.HttpMethod
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpStatusCode
import io.ktor.http.Parameters
import io.ktor.http.ParametersBuilder
import io.ktor.http.isSuccess
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.JsonNull
import kotlinx.serialization.json.put
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.contentOrNull
import kotlinx.serialization.json.encodeToJsonElement
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import kotlinx.coroutines.CancellationException

object KtorApiClient {
    private const val TAG = "[DATA_RETRIEVE_SC] KtorApiClient"

    private val json = Json {
        isLenient = true
        ignoreUnknownKeys = true
        explicitNulls = false
    }

    // Bulk exam result saves must retain null rank values. The general client
    // omits nulls for optional request fields, but the exam API distinguishes
    // an unset rank from its server-side default.
    private val examResultRequestJson = Json {
        isLenient = true
        ignoreUnknownKeys = true
        explicitNulls = true
    }

    private val client = HttpClient {
        install(ContentNegotiation) {
            json(json)
        }
        // Retry only safe reads. Mutations are intentionally excluded so a
        // transient response cannot duplicate OTP, create, update, or upload
        // operations unless the endpoint has explicit idempotency support.
        install(HttpRequestRetry) {
            retryIf(maxRetries = NetworkConstants.MAX_API_RETRIES) { request, response ->
                request.method == HttpMethod.Get && response.status.value.let {
                    it == 408 || it == 429 || it in 500..599
                }
            }
            retryOnExceptionIf(maxRetries = NetworkConstants.MAX_API_RETRIES) { request, cause ->
                request.method == HttpMethod.Get && cause !is CancellationException
            }
            exponentialDelay(
                baseDelayMs = 500,
                randomizationMs = 250,
                respectRetryAfterHeader = true
            )
        }
        install(HttpTimeout) {
            requestTimeoutMillis = NetworkConstants.DEFAULT_TIMEOUT_MS
            socketTimeoutMillis = NetworkConstants.DEFAULT_TIMEOUT_MS
            connectTimeoutMillis = NetworkConstants.DEFAULT_TIMEOUT_MS
        }
        install(Logging) {
            logger = if (BuildConfig.platform() == PlatformType.ANDROID) {
                object : Logger {
                    override fun log(message: String) {
                        scLog(message)
                    }
                }
            } else {
                object : Logger {
                    override fun log(message: String) = Unit
                }
            }
            level = if (BuildConfig.isDebug()) LogLevel.INFO else LogLevel.NONE
        }
    }

    /** Downloads public binary assets such as the school logo returned by the API. */
    suspend fun downloadAssetBytes(url: String): Result<ByteArray> {
        val normalizedUrl = url.trim()
        if (normalizedUrl.isBlank()) return Result.failure(IllegalArgumentException("Asset URL is blank"))
        return runCatching {
            val response = client.request(normalizedUrl) {
                method = HttpMethod.Get
            }
            if (!response.status.isSuccess()) {
                error("Asset request failed with HTTP ${response.status.value}")
            }
            response.body<ByteArray>()
        }
    }

    suspend fun requestFileUpload(request: FileUploadRequest): Result<FileUploadGrant> {
        val normalized = request.copy(
            module = request.module.trim(),
            recordId = request.recordId?.trim()?.takeIf { it.isNotBlank() },
            filename = request.filename.trim(),
            contentType = request.contentType.trim(),
            sizeBytes = request.sizeBytes.coerceAtLeast(0)
        )
        scLog(
            "$TAG requestFileUpload module=${normalized.module} recordId=${normalized.recordId ?: "<new>"} " +
                "fileName=${normalized.filename} bytes=${normalized.sizeBytes}"
        )
        return postJson(
            url = NetworkConstants.FILE_UPLOAD_REQUESTS_URL,
            body = normalized,
            authenticated = true
        )
    }

    /** Requests the documented current-user profile-picture upload grant. */
    suspend fun requestProfilePictureUpload(request: FileUploadRequest): Result<FileUploadGrant> {
        val normalized = request.copy(
            module = request.module.trim().ifBlank { "PROFILE" },
            recordId = request.recordId?.trim()?.takeIf { it.isNotBlank() },
            filename = request.filename.trim(),
            contentType = request.contentType.trim(),
            sizeBytes = request.sizeBytes.coerceAtLeast(0)
        )
        scLog(
            "$TAG requestProfilePictureUpload recordId=${normalized.recordId ?: "<current-user>"} " +
                "fileName=${normalized.filename} bytes=${normalized.sizeBytes}"
        )
        return postJson(
            url = NetworkConstants.PROFILE_PIC_UPLOAD_URL,
            body = normalized,
            authenticated = true
        )
    }

    /** Uploads bytes to the storage URL returned by requestFileUpload. */
    suspend fun uploadFileBytes(
        grant: FileUploadGrant,
        bytes: ByteArray,
        contentType: String
    ): Result<Unit> {
        val fileId = grant.fileId?.trim().orEmpty()
        val upload = grant.upload
        val uploadUrl = sequenceOf("url", "presigned_url", "upload_url")
            .mapNotNull { upload[it]?.jsonPrimitive?.contentOrNull?.trim() }
            .firstOrNull { it.isNotBlank() }
        if (fileId.isBlank()) return Result.failure(IllegalStateException("Upload grant did not contain file_id"))
        if (uploadUrl.isNullOrBlank()) {
            return Result.failure(IllegalStateException("Upload grant did not contain a presigned upload URL"))
        }

        return NetworkActivityTracker.track(showBlockingLoader = true) {
            try {
                val response = client.request(uploadUrl) {
                    method = HttpMethod.Put
                    header(HttpHeaders.ContentType, contentType.trim().ifBlank { ContentType.Application.OctetStream.toString() })
                    upload["headers"]?.jsonObject?.forEach { (name, value) ->
                        val headerValue = value.jsonPrimitive.contentOrNull
                        if (!headerValue.isNullOrBlank() && !name.equals(HttpHeaders.ContentType, ignoreCase = true)) {
                            header(name, headerValue)
                        }
                    }
                    setBody(bytes)
                }
                if (response.status.isSuccess()) Result.success(Unit) else response.failureResult()
            } catch (throwable: Throwable) {
                // Do not turn structured coroutine cancellation into a
                // user-facing error when an operation is superseded.
                if (throwable is CancellationException) throw throwable
                AppErrorCenter.emit(throwable, source = TAG)
                Result.failure(throwable)
            }
        }
    }

    suspend fun confirmFileUpload(fileId: String): Result<FileConfirmResponse> {
        val normalizedFileId = fileId.trim()
        require(normalizedFileId.isNotBlank()) { "fileId must not be blank" }
        return postJsonWithoutBody(
            url = "${NetworkConstants.FILES_URL}/$normalizedFileId/confirm",
            authenticated = true
        )
    }

    suspend fun getFileMetadata(fileId: String): Result<FileObjectResponse> =
        getJson("${NetworkConstants.FILES_URL}/${fileId.trim()}", authenticated = true)

    suspend fun getFileDownloadUrl(fileId: String): Result<FileDownloadUrlResponse> =
        getJson("${NetworkConstants.FILES_URL}/${fileId.trim()}/download-url", authenticated = true)

    suspend fun listRecordFiles(recordId: String, module: String? = null): Result<FileListResponse> {
        val url = buildUrlWithQuery(
            "${NetworkConstants.FILES_URL}/records/${recordId.trim()}/files",
            "module" to module?.trim()?.takeIf { it.isNotBlank() }
        )
        return getJson(url, authenticated = true)
    }

    suspend fun listDocuments(
        query: String? = null,
        category: String? = null,
        applicableTo: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null,
        studentId: String? = null
    ): Result<DocumentLibraryListResponse> {
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            NetworkConstants.DOCUMENT_LIBRARY_URL,
            "q" to query?.trim()?.takeIf { it.isNotBlank() },
            "category" to category?.trim()?.takeIf { it.isNotBlank() },
            "applicable_to" to applicableTo?.trim()?.takeIf { it.isNotBlank() },
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" },
            "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG listDocuments url=$url limit=$safeLimit offset=$safeOffset")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getDocument(documentId: String, studentId: String? = null): Result<DocumentResponseDTO> {
        val id = documentId.trim()
        require(id.isNotBlank()) { "documentId must not be blank" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.DOCUMENT_LIBRARY_URL}$id",
            "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() }
        )
        return getJson(url, authenticated = true)
    }

    suspend fun getDocumentMetrics(): Result<com.schoolconnect.app.datasource.network.response.DocumentMetricsDTO> =
        getJson("${NetworkConstants.DOCUMENT_LIBRARY_URL}metrics", authenticated = true)

    suspend fun getDocumentDownloadUrl(documentId: String, studentId: String? = null): Result<FileDownloadUrlResponse> {
        val id = documentId.trim()
        require(id.isNotBlank()) { "documentId must not be blank" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.DOCUMENT_LIBRARY_URL}$id/download-url",
            "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() }
        )
        return getJson(url, authenticated = true)
    }

    suspend fun createDocument(request: DocumentCreateRequest): Result<DocumentResponseDTO> =
        postJson(
            url = NetworkConstants.DOCUMENT_LIBRARY_URL,
            body = request.copy(
                schoolId = request.schoolId.trim(),
                title = request.title.trim(),
                description = request.description?.trim()?.takeIf { it.isNotBlank() },
                category = request.category.trim(),
                applicableTo = request.applicableTo.trim(),
                fileId = request.fileId?.trim()?.takeIf { it.isNotBlank() }
            ),
            authenticated = true
        )

    suspend fun updateDocument(documentId: String, request: DocumentUpdateRequest): Result<DocumentResponseDTO> {
        val id = documentId.trim()
        require(id.isNotBlank()) { "documentId must not be blank" }
        return requestJson(
            url = "${NetworkConstants.DOCUMENT_LIBRARY_URL}${encodePathSegment(id)}",
            method = HttpMethod.Put,
            authenticated = true,
            body = request.copy(
                title = request.title?.trim(),
                description = request.description?.trim()?.takeIf { it.isNotBlank() },
                category = request.category?.trim(),
                applicableTo = request.applicableTo?.trim()
            )
        )
    }

    suspend fun deleteFile(fileId: String): Result<Unit> =
        authenticatedMutation("${NetworkConstants.FILES_URL}/${fileId.trim()}", HttpMethod.Delete)

    suspend fun restoreFile(fileId: String): Result<FileRestoreResponse> =
        postJsonWithoutBody(
            url = "${NetworkConstants.FILES_URL}/${fileId.trim()}/restore",
            authenticated = true
        )

    suspend fun requestOtp(email: String): Result<RequestOtpResponse> {
        scLog("$TAG requestOtp email=$email url=${NetworkConstants.AUTH_REQUEST_OTP_URL}")
        return postJson(
            url = NetworkConstants.AUTH_REQUEST_OTP_URL,
            body = RequestOtpRequest(email = email.trim()),
            authenticated = false
        )
    }

    suspend fun verifyOtp(email: String, otpCode: String): Result<VerifyOtpResponse> {
        scLog("$TAG verifyOtp email=$email url=${NetworkConstants.AUTH_VERIFY_OTP_URL}")
        return postJson(
            url = NetworkConstants.AUTH_VERIFY_OTP_URL,
            body = VerifyOtpRequest(email = email.trim(), otpCode = otpCode.trim()),
            authenticated = false
        )
    }

    suspend fun logout(): Result<Unit> {
        scLog("$TAG logout url=${NetworkConstants.AUTH_LOGOUT_URL}")
        return authenticatedMutation(NetworkConstants.AUTH_LOGOUT_URL, HttpMethod.Post)
    }

    suspend fun getCurrentAppStaffProfile(): Result<AppStaffResponse> {
        scLog("$TAG getCurrentAppStaffProfile url=${NetworkConstants.APP_STAFF_ME_URL}")
        return getJson(url = NetworkConstants.APP_STAFF_ME_URL, authenticated = true)
    }

    suspend fun getAppStaffProfile(staffId: String): Result<AppStaffResponse> {
        val normalizedStaffId = staffId.trim()
        require(normalizedStaffId.isNotBlank()) { "staffId must not be blank" }
        val url = "${NetworkConstants.APP_STAFF_URL}${encodePathSegment(normalizedStaffId)}"
        scLog("$TAG getAppStaffProfile staffId=$normalizedStaffId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getCurrentSchoolStaffProfile(): Result<SchoolStaffResponse> {
        scLog("$TAG getCurrentSchoolStaffProfile url=${NetworkConstants.SCHOOL_STAFF_ME_URL}")
        return getJson(url = NetworkConstants.SCHOOL_STAFF_ME_URL, authenticated = true)
    }

    suspend fun updateTeacherOwnProfile(request: SchoolStaffUpdateRequest): Result<SchoolStaffResponse> =
        requestJson(
            url = "${NetworkConstants.SCHOOL_STAFF_URL}teachers/me",
            method = HttpMethod.Put,
            authenticated = true,
            body = request
        )

    suspend fun getCurrentParentProfile(): Result<ParentResponse> {
        scLog("$TAG getCurrentParentProfile url=${NetworkConstants.PARENT_ME_URL}")
        return getJson(url = NetworkConstants.PARENT_ME_URL, authenticated = true)
    }

    suspend fun getDashboardAnalytics(): Result<DashboardAnalyticsResponse> {
        scLog("$TAG getDashboardAnalytics url=${NetworkConstants.DASHBOARD_ANALYTICS_URL}")
        return getJson(
            url = NetworkConstants.DASHBOARD_ANALYTICS_URL,
            authenticated = true
        )
    }

    suspend fun getSchoolsDashboardAnalytics(): Result<DashboardSchoolsAnalyticsResponse> {
        return getSchoolsAnalytics()
    }

    suspend fun getSchoolsAnalytics(): Result<DashboardSchoolsAnalyticsResponse> {
        scLog("$TAG getSchoolsAnalytics url=${NetworkConstants.SCHOOLS_ANALYTICS_URL}")
        return getJson(
            url = NetworkConstants.SCHOOLS_ANALYTICS_URL,
            authenticated = true
        )
    }

    suspend fun getSchoolAnalytics(schoolCode: String): Result<SchoolAnalyticsResponse> {
        val normalizedCode = schoolCode.trim()
        val url = "${NetworkConstants.SCHOOLS_URL}${encodeQueryComponent(normalizedCode)}/analytics"
        scLog("$TAG getSchoolAnalytics url=$url schoolCode=${normalizedCode.ifBlank { "<blank>" }}")
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun getAcademicYears(
        schoolId: String? = null,
        lifecycle: String? = null,
        query: String? = null,
        startYear: Int? = null,
        endYear: Int? = null,
        createdFrom: String? = null,
        createdTo: String? = null,
        limit: Int = 20,
        offset: Int = 0
    ): Result<List<AcademicYearResponse>> {
        val normalizedSchoolId = schoolId?.trim()?.takeIf { it.isNotBlank() }
        val normalizedQuery = query?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.ACADEMIC_YEARS_URL,
            "school_id" to normalizedSchoolId,
            "lifecycle" to lifecycle?.trim()?.takeIf { it.isNotBlank() },
            "q" to normalizedQuery,
            "start_year" to startYear?.toString(),
            "end_year" to endYear?.toString(),
            "created_from" to createdFrom?.trim()?.takeIf { it.isNotBlank() },
            "created_to" to createdTo?.trim()?.takeIf { it.isNotBlank() },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString()
        )
        scLog(
            "$TAG getAcademicYears url=$url school=${normalizedSchoolId ?: "<any>"} lifecycle=${lifecycle?.trim()?.ifBlank { null } ?: "<any>"} query=${normalizedQuery ?: "<blank>"} limit=${limit.coerceIn(1, 100)} offset=${offset.coerceAtLeast(0)}"
        )
        return getRecordList<AcademicYearResponse>(
            url = url,
            authenticated = true
        )
    }

    suspend fun getAcademicYearsWithSchoolName(
        schoolId: String? = null,
        schoolName: String? = null,
        lifecycle: String? = null,
        query: String? = null,
        startYear: Int? = null,
        endYear: Int? = null,
        createdFrom: String? = null,
        createdTo: String? = null,
        isActive: Boolean? = null,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<AcademicYearWithSchoolResponse>> {
        val normalizedSchoolId = schoolId?.trim()?.takeIf { it.isNotBlank() }
        val normalizedSchoolName = schoolName?.trim()?.takeIf { it.isNotBlank() }
        val normalizedQuery = query?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.ACADEMIC_YEARS_WITH_SCHOOL_NAME_URL,
            "school_id" to normalizedSchoolId,
            "school_name" to normalizedSchoolName,
            "lifecycle" to lifecycle?.trim()?.takeIf { it.isNotBlank() },
            "q" to normalizedQuery,
            "start_year" to startYear?.toString(),
            "end_year" to endYear?.toString(),
            "created_from" to createdFrom?.trim()?.takeIf { it.isNotBlank() },
            "created_to" to createdTo?.trim()?.takeIf { it.isNotBlank() },
            "is_active" to isActive?.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { (it == "asc" || it == "desc") && sortBy?.isNotBlank() == true }
        )
        scLog(
            "$TAG getAcademicYearsWithSchoolName url=$url school=${normalizedSchoolId ?: "<any>"} schoolName=${normalizedSchoolName ?: "<any>"} lifecycle=${lifecycle?.trim()?.ifBlank { null } ?: "<any>"} query=${normalizedQuery ?: "<blank>"}"
        )
        return getRecordList<AcademicYearWithSchoolResponse>(url = url, authenticated = true)
    }

    suspend fun getSchoolConfigs(
        schoolId: String? = null,
        academicYear: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null,
        isActive: Boolean? = null
    ): Result<List<SchoolConfigListItemResponse>> {
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            "${NetworkConstants.SCHOOL_CONFIG_URL}/",
            "school_id" to schoolId?.trim()?.takeIf { it.isNotBlank() },
            "academic_year" to academicYear?.trim()?.takeIf { it.isNotBlank() },
            "is_active" to isActive?.toString(),
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getSchoolConfigs url=$url limit=$safeLimit offset=$safeOffset isActive=${isActive?.toString() ?: "<any>"}")
        return getRecordList<SchoolConfigListItemResponse>(url = url, authenticated = true)
    }

    suspend fun getSchoolConfig(schoolId: String, academicYear: String? = null, academicYearId: String? = null): Result<SchoolConfigurationResponse> {
        val normalizedSchoolId = schoolId.trim()
        require(normalizedSchoolId.isNotBlank()) { "schoolId must not be blank" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.SCHOOL_CONFIG_URL}/${encodePathSegment(normalizedSchoolId)}",
            "academic_year" to academicYear?.trim()?.takeIf { it.isNotBlank() },
            "academic_year_id" to academicYearId?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG getSchoolConfig school=$normalizedSchoolId")
        return getJson(url, authenticated = true)
    }

    suspend fun downloadSchoolHolidayTemplate(): Result<ByteArray> =
        downloadExcel(NetworkConstants.SCHOOL_CONFIG_HOLIDAY_TEMPLATE_URL, "School_Holidays_Import.xlsx")

    suspend fun importSchoolHolidays(
        schoolId: String,
        fileName: String,
        fileBytes: ByteArray,
        academicYearId: String? = null
    ): Result<HolidayImportResponse> {
        val normalizedSchoolId = schoolId.trim()
        val normalizedName = fileName.trim().ifBlank { "School_Holidays_Import.xlsx" }
        require(normalizedSchoolId.isNotBlank()) { "schoolId must not be blank" }
        require(fileBytes.isNotEmpty()) { "Import file must not be empty" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.SCHOOL_CONFIG_HOLIDAY_IMPORT_URL}/${encodePathSegment(normalizedSchoolId)}/holidays/import",
            "academic_year_id" to academicYearId?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG importSchoolHolidays school=$normalizedSchoolId fileName=$normalizedName bytes=${fileBytes.size}")
        return postMultipartFormData(
            url = url,
            authenticated = true,
            body = MultiPartFormDataContent(formData {
                appendMultipartFile(
                    name = "file",
                    bytes = fileBytes,
                    fileName = normalizedName,
                    contentType = ContentType.parse("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                )
            })
        )
    }

    suspend fun updateSchoolConfigGeneral(
        schoolId: String,
        request: SchoolConfigGeneralUpdateRequest,
        academicYearId: String? = null
    ): Result<SchoolConfigurationResponse> = updateSchoolConfigPart(
        schoolId = schoolId,
        suffix = "",
        request = request,
        academicYearId = academicYearId
    )

    suspend fun updateSchoolConfigCalendar(
        schoolId: String,
        request: SchoolConfigCalendarUpdateRequest,
        academicYearId: String? = null
    ): Result<List<com.schoolconnect.app.datasource.network.response.SchoolHolidayResponse>> = requestJson(
        url = schoolConfigMutationUrl(schoolId, "/calendar", academicYearId),
        method = HttpMethod.Put,
        authenticated = true,
        body = request
    )

    suspend fun updateSchoolConfigFeatures(
        schoolId: String,
        request: SchoolConfigFeatureUpdateRequest,
        academicYearId: String? = null
    ): Result<List<com.schoolconnect.app.datasource.network.response.SchoolFeatureConfigResponse>> = requestJson(
        url = schoolConfigMutationUrl(schoolId, "/features", academicYearId),
        method = HttpMethod.Put,
        authenticated = true,
        body = request
    )

    suspend fun getWeeklyHolidayConfigs(
        schoolId: String,
        academicYearId: String? = null
    ): Result<List<SchoolWeeklyHolidayConfigResponse>> {
        val normalizedSchoolId = schoolId.trim()
        require(normalizedSchoolId.isNotBlank()) { "schoolId must not be blank" }
        val url = buildUrlWithQuery(
            NetworkConstants.WEEKLY_HOLIDAY_CONFIG_URL,
            "school_id" to normalizedSchoolId,
            "academic_year_id" to academicYearId?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG getWeeklyHolidayConfigs school=$normalizedSchoolId")
        return getJson(url, authenticated = true)
    }

    suspend fun upsertWeeklyHolidayConfig(
        schoolId: String,
        dayOfWeek: Int
    ): Result<SchoolWeeklyHolidayConfigResponse> {
        val normalizedSchoolId = schoolId.trim()
        require(normalizedSchoolId.isNotBlank()) { "schoolId must not be blank" }
        require(dayOfWeek in 0..6) { "dayOfWeek must be between 0 and 6" }
        val url = buildUrlWithQuery(
            NetworkConstants.WEEKLY_HOLIDAY_CONFIG_URL,
            "school_id" to normalizedSchoolId
        )
        scLog("$TAG upsertWeeklyHolidayConfig school=$normalizedSchoolId dayOfWeek=$dayOfWeek")
        return requestJson(
            url = url,
            method = HttpMethod.Post,
            authenticated = true,
            body = SchoolWeeklyHolidayConfigCreateRequest(dayOfWeek)
        )
    }

    private suspend fun updateSchoolConfigPart(
        schoolId: String,
        suffix: String,
        request: Any,
        academicYearId: String?
    ): Result<SchoolConfigurationResponse> = requestJson(
        url = schoolConfigMutationUrl(schoolId, suffix, academicYearId),
        method = HttpMethod.Put,
        authenticated = true,
        body = request
    )

    private fun schoolConfigMutationUrl(schoolId: String, suffix: String, academicYearId: String? = null): String {
        val normalizedSchoolId = schoolId.trim()
        require(normalizedSchoolId.isNotBlank()) { "schoolId must not be blank" }
        return buildUrlWithQuery(
            "${NetworkConstants.SCHOOL_CONFIG_URL}/${encodePathSegment(normalizedSchoolId)}$suffix",
            "academic_year_id" to academicYearId?.trim()?.takeIf { it.isNotBlank() }
        )
    }

    suspend fun getSupportQueue(
        query: String? = null,
        schoolId: String? = null,
        requesterRole: String? = null,
        status: String? = null,
        assignedToId: String? = null,
        periodStart: String? = null,
        periodEnd: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<TicketListItemResponse>> {
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            NetworkConstants.SUPPORT_QUEUE_URL,
            "q" to query?.trim()?.takeIf { it.isNotBlank() },
            "school_id" to schoolId?.trim()?.takeIf { it.isNotBlank() },
            "requester_role" to requesterRole?.trim()?.takeIf { it.isNotBlank() },
            "status" to status?.trim()?.takeIf { it.isNotBlank() },
            "assigned_to_id" to assignedToId?.trim()?.takeIf { it.isNotBlank() },
            "period_start" to periodStart?.trim()?.takeIf { it.isNotBlank() },
            "period_end" to periodEnd?.trim()?.takeIf { it.isNotBlank() },
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getSupportQueue url=$url limit=$safeLimit offset=$safeOffset")
        return getRecordList<TicketListItemResponse>(url = url, authenticated = true)
    }

    suspend fun getSupportTickets(
        query: String? = null,
        status: String? = null,
        periodStart: String? = null,
        periodEnd: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<TicketListItemResponse>> {
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            NetworkConstants.SUPPORT_TICKETS_URL,
            "q" to query?.trim()?.takeIf { it.isNotBlank() },
            "status" to status?.trim()?.takeIf { it.isNotBlank() },
            "period_start" to periodStart?.trim()?.takeIf { it.isNotBlank() },
            "period_end" to periodEnd?.trim()?.takeIf { it.isNotBlank() },
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getSupportTickets url=$url limit=$safeLimit offset=$safeOffset")
        return getRecordList<TicketListItemResponse>(url = url, authenticated = true)
    }

    suspend fun getSupportTicketStatistics(): Result<SupportTicketStatisticsResponse> {
        val url = NetworkConstants.SUPPORT_TICKETS_STATISTICS_URL
        scLog("$TAG getSupportTicketStatistics url=$url")
        return getJson(url = url, authenticated = true)
    }

    suspend fun createSupportTicket(
        subject: String,
        description: String,
        category: String? = null,
        attachmentFileIds: List<String> = emptyList()
    ): Result<Unit> {
        val normalizedSubject = subject.trim()
        val normalizedDescription = description.trim()
        require(normalizedSubject.isNotBlank()) { "Ticket subject must not be blank" }
        require(normalizedDescription.isNotBlank()) { "Ticket description must not be blank" }
        val url = NetworkConstants.SUPPORT_TICKETS_URL
        val normalizedAttachmentIds = attachmentFileIds.map { it.trim() }.filter { it.isNotBlank() }
        scLog("$TAG createSupportTicket url=$url attachmentCount=${normalizedAttachmentIds.size}")
        return authenticatedMutation(
            url = url,
            method = HttpMethod.Post,
            body = MultiPartFormDataContent(formData {
                append("subject", normalizedSubject)
                append("description", normalizedDescription)
                category?.trim()?.takeIf { it.isNotBlank() }?.let { append("category", it) }
                normalizedAttachmentIds.takeIf { it.isNotEmpty() }?.let { append("attachment_file_ids", it.joinToString(",")) }
            })
        )
    }

    suspend fun getSupportTicketDetails(ticketId: String): Result<TicketResponse> {
        val id = ticketId.trim()
        require(id.isNotBlank()) { "ticketId must not be blank" }
        val url = "${NetworkConstants.SUPPORT_TICKETS_URL}/${encodePathSegment(id)}"
        scLog("$TAG getSupportTicketDetails ticketId=$id")
        return getJson(url = url, authenticated = true)
    }

    suspend fun replyToSupportTicket(
        ticketId: String,
        message: String,
        attachmentFileIds: List<String> = emptyList()
    ): Result<TicketResponse> {
        val id = ticketId.trim()
        val normalizedMessage = message.trim()
        require(id.isNotBlank()) { "ticketId must not be blank" }
        require(normalizedMessage.isNotBlank()) { "Reply message must not be blank" }
        val url = "${NetworkConstants.SUPPORT_TICKETS_URL}/${encodePathSegment(id)}/reply"
        val normalizedAttachmentIds = attachmentFileIds.map { it.trim() }.filter { it.isNotBlank() }
        scLog("$TAG replyToSupportTicket ticketId=$id attachmentCount=${normalizedAttachmentIds.size}")
        return postMultipartFormData(
            url = url,
            body = MultiPartFormDataContent(formData {
                append("message", normalizedMessage)
                normalizedAttachmentIds.takeIf { it.isNotEmpty() }?.let { append("attachment_file_ids", it.joinToString(",")) }
            }),
            authenticated = true
        )
    }

    suspend fun createSupportQueueTicket(
        schoolId: String,
        subject: String,
        description: String,
        category: String? = null,
        assigneeId: String? = null,
        attachmentName: String? = null,
        attachmentBytes: ByteArray? = null,
        attachmentContentType: ContentType? = null
    ): Result<Unit> {
        val normalizedSchoolId = schoolId.trim()
        val normalizedSubject = subject.trim()
        val normalizedDescription = description.trim()
        require(normalizedSchoolId.isNotBlank()) { "School must not be blank" }
        require(normalizedSubject.isNotBlank()) { "Ticket subject must not be blank" }
        require(normalizedDescription.isNotBlank()) { "Ticket description must not be blank" }
        require((attachmentBytes == null) == (attachmentName == null)) { "Attachment name and bytes must be provided together" }
        val url = NetworkConstants.SUPPORT_QUEUE_TICKETS_URL
        scLog("$TAG createSupportQueueTicket url=$url schoolId=$normalizedSchoolId assignee=${assigneeId ?: "<none>"}")
        return authenticatedMutation(
            url = url,
            method = HttpMethod.Post,
            body = MultiPartFormDataContent(formData {
                append("school_id", normalizedSchoolId)
                append("subject", normalizedSubject)
                append("description", normalizedDescription)
                category?.trim()?.takeIf { it.isNotBlank() }?.let { append("category", it) }
                assigneeId?.trim()?.takeIf { it.isNotBlank() }?.let { append("assignee_id", it) }
                if (attachmentBytes != null && attachmentName != null) {
                    appendMultipartFile(
                        name = "attachment",
                        bytes = attachmentBytes,
                        fileName = attachmentName,
                        contentType = attachmentContentType ?: ContentType.Application.OctetStream
                    )
                }
            })
        )
    }

    suspend fun getSupportQueueTicketDetails(ticketId: String): Result<TicketResponse> {
        val id = ticketId.trim()
        require(id.isNotBlank()) { "ticketId must not be blank" }
        val url = "${NetworkConstants.SUPPORT_QUEUE_TICKETS_URL}/${encodePathSegment(id)}"
        scLog("$TAG getSupportQueueTicketDetails ticketId=$id")
        return getJson(url = url, authenticated = true)
    }

    suspend fun replyToSupportQueueTicket(
        ticketId: String,
        message: String,
        attachmentName: String? = null,
        attachmentBytes: ByteArray? = null,
        attachmentContentType: ContentType? = null
    ): Result<Unit> {
        val id = ticketId.trim()
        val normalizedMessage = message.trim()
        require(id.isNotBlank()) { "ticketId must not be blank" }
        require(normalizedMessage.isNotBlank()) { "Reply message must not be blank" }
        require((attachmentBytes == null) == (attachmentName == null)) { "Attachment name and bytes must be provided together" }
        val url = "${NetworkConstants.SUPPORT_QUEUE_TICKETS_URL}/${encodePathSegment(id)}/reply"
        scLog("$TAG replyToSupportQueueTicket ticketId=$id")
        return authenticatedMutation(
            url = url,
            method = HttpMethod.Post,
            body = MultiPartFormDataContent(formData {
                append("message", normalizedMessage)
                if (attachmentBytes != null && attachmentName != null) {
                    appendMultipartFile(
                        name = "attachment",
                        bytes = attachmentBytes,
                        fileName = attachmentName,
                        contentType = attachmentContentType ?: ContentType.Application.OctetStream
                    )
                }
            })
        )
    }

    suspend fun updateSupportQueueTicketStatusAssignment(
        ticketId: String,
        status: String,
        assigneeId: String? = null
    ): Result<Unit> {
        val id = ticketId.trim()
        val normalizedStatus = status.trim().uppercase().replace(' ', '_')
        require(id.isNotBlank()) { "ticketId must not be blank" }
        require(normalizedStatus.isNotBlank()) { "status must not be blank" }
        val url = "${NetworkConstants.SUPPORT_QUEUE_TICKETS_URL}/${encodePathSegment(id)}/status-assignment"
        scLog("$TAG updateSupportQueueTicketStatusAssignment ticketId=$id status=$normalizedStatus assignee=${assigneeId ?: "<none>"}")
        return authenticatedMutation(
            url = url,
            method = HttpMethod.Put,
            body = MultiPartFormDataContent(formData {
                append("status", normalizedStatus)
                assigneeId?.trim()?.takeIf { it.isNotBlank() }?.let { append("assignee_id", it) }
            })
        )
    }

    suspend fun getCurrentAcademicYear(schoolId: String): Result<AcademicYearResponse?> {
        val normalizedSchoolId = schoolId.trim()
        // The current-year endpoint derives school scope from the authenticated
        // user's active context; school_id is no longer a documented query
        // parameter. Keep the argument for repository/cache compatibility while
        // avoiding an undocumented request field.
        val url = NetworkConstants.ACADEMIC_YEARS_CURRENT_URL
        scLog("$TAG getCurrentAcademicYear url=$url schoolId=$normalizedSchoolId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getAcademicYear(academicYearId: String): Result<AcademicYearResponse> {
        val normalizedId = academicYearId.trim()
        val url = "${NetworkConstants.ACADEMIC_YEARS_URL}${encodeQueryComponent(normalizedId)}"
        scLog("$TAG getAcademicYear url=$url academicYearId=$normalizedId")
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun createAcademicYear(request: AcademicYearCreateRequest): Result<AcademicYearResponse> {
        val url = NetworkConstants.ACADEMIC_YEARS_URL
        scLog(
            "$TAG createAcademicYear url=$url schoolId=${request.schoolId.ifBlank { "<blank>" }} label=${request.label.ifBlank { "<blank>" }}"
        )
        return postJson(
            url = url,
            body = request,
            authenticated = true
        )
    }

    suspend fun updateAcademicYear(
        academicYearId: String,
        request: AcademicYearUpdateRequest
    ): Result<AcademicYearResponse> {
        val normalizedId = academicYearId.trim()
        require(normalizedId.isNotBlank()) { "academicYearId is required" }
        val url = "${NetworkConstants.ACADEMIC_YEARS_URL}${encodeQueryComponent(normalizedId)}"
        scLog("$TAG updateAcademicYear url=$url academicYearId=$normalizedId")
        return requestJson(
            url = url,
            method = HttpMethod.Put,
            authenticated = true,
            body = request
        )
    }

    suspend fun toggleAcademicYearActive(
        academicYearId: String,
        isActive: Boolean
    ): Result<Unit> {
        val normalizedId = academicYearId.trim()
        val url = "${NetworkConstants.ACADEMIC_YEARS_URL}${encodeQueryComponent(normalizedId)}/toggle-active"
        scLog(
            "$TAG toggleAcademicYearActive url=$url academicYearId=$normalizedId isActive=$isActive"
        )
        return authenticatedMutation(
            url = url,
            method = HttpMethod.Patch,
            body = AcademicYearToggleActiveRequest(isActive = isActive)
        )
    }

    suspend fun deleteAcademicYear(academicYearId: String): Result<Unit> {
        val normalizedId = academicYearId.trim()
        val url = "${NetworkConstants.ACADEMIC_YEARS_URL}${encodeQueryComponent(normalizedId)}"
        scLog("$TAG deleteAcademicYear url=$url academicYearId=$normalizedId")
        return authenticatedMutation(url, HttpMethod.Delete)
    }

    suspend fun listTimetables(
        classSectionId: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<RecordListResponse<TimetableClassHeaderResponse>> {
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            NetworkConstants.TIMETABLE_URL,
            "class_section_id" to classSectionId?.trim()?.takeIf { it.isNotBlank() },
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG listTimetables url=$url limit=$safeLimit offset=$safeOffset")
        return getJson(url = url, authenticated = true)
    }

    suspend fun createTimetable(request: TimetableCombinedCreateRequest): Result<TimetableViewResponse> =
        postJson(NetworkConstants.TIMETABLE_URL, request, authenticated = true)

    suspend fun updateTimetable(headerId: String, request: TimetableCombinedUpdateRequest): Result<TimetableViewResponse> {
        val normalizedId = headerId.trim()
        require(normalizedId.isNotBlank()) { "headerId must not be blank" }
        val url = "${NetworkConstants.TIMETABLE_URL}${encodeQueryComponent(normalizedId)}"
        return requestJson(url = url, method = HttpMethod.Put, authenticated = true, body = request)
    }

    suspend fun getTimetable(headerId: String): Result<TimetableViewResponse> {
        val normalizedId = headerId.trim()
        require(normalizedId.isNotBlank()) { "headerId must not be blank" }
        val url = "${NetworkConstants.TIMETABLE_URL}${encodeQueryComponent(normalizedId)}"
        scLog("$TAG getTimetable headerId=$normalizedId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentTimetable(studentId: String, weekStart: String? = null): Result<ParentTimetableWeekResponse> {
        val normalizedStudentId = studentId.trim()
        require(normalizedStudentId.isNotBlank()) { "studentId must not be blank" }
        val url = buildUrlWithQuery(
            NetworkConstants.PARENT_TIMETABLE_VIEW_URL,
            "student_id" to normalizedStudentId,
            "week_start" to weekStart?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG getParentTimetable studentId=$normalizedStudentId weekStart=${weekStart ?: "<default>"}")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getTeacherTimetableClasses(): Result<List<TeacherTimetableClassResponse>> {
        scLog("$TAG getTeacherTimetableClasses")
        return getJson(url = NetworkConstants.TEACHER_TIMETABLE_MY_CLASSES_URL, authenticated = true)
    }

    suspend fun getTeacherTimetable(classSectionId: String, weekStart: String? = null): Result<WeeklyTimetableResponse> {
        val normalizedId = classSectionId.trim()
        require(normalizedId.isNotBlank()) { "classSectionId must not be blank" }
        val url = buildUrlWithQuery(
            NetworkConstants.TEACHER_TIMETABLE_VIEW_URL,
            "class_section_id" to normalizedId,
            "week_start" to weekStart?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG getTeacherTimetable classSectionId=$normalizedId weekStart=${weekStart ?: "<default>"}")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getClassSections(
        schoolId: String,
        academicYearId: String,
        isActive: Boolean? = null,
        limit: Int = 50,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<ClassSectionResponse>> {
        val normalizedSchoolId = schoolId.trim()
        val normalizedAcademicYearId = academicYearId.trim()
        // The current OpenAPI contract derives school scope from the
        // authenticated context; school_id is not a documented query field.
        val url = buildUrlWithQuery(
            NetworkConstants.CLASS_SECTIONS_URL,
            "academic_year_id" to normalizedAcademicYearId,
            "is_active" to isActive?.toString(),
            "limit" to limit.coerceAtLeast(1).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog(
            "$TAG getClassSections url=$url school=$normalizedSchoolId academicYear=$normalizedAcademicYearId isActive=${isActive?.toString() ?: "<any>"} limit=${limit.coerceAtLeast(1)} offset=${offset.coerceAtLeast(0)}"
        )
        return getRecordList<ClassSectionResponse>(
            url = url,
            authenticated = true
        )
    }

    suspend fun getClassSectionsWithSubjects(
        schoolId: String,
        academicYearId: String,
        isActive: Boolean? = null,
        limit: Int = 50,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<ClassSectionResponse>> {
        val normalizedSchoolId = schoolId.trim()
        val normalizedAcademicYearId = academicYearId.trim()
        // The current OpenAPI contract derives school scope from the
        // authenticated context; school_id is not a documented query field.
        val url = buildUrlWithQuery(
            NetworkConstants.CLASS_SECTIONS_WITH_SUBJECTS_URL,
            "academic_year_id" to normalizedAcademicYearId,
            "is_active" to isActive?.toString(),
            "limit" to limit.coerceAtLeast(1).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog(
            "$TAG getClassSectionsWithSubjects url=$url school=$normalizedSchoolId academicYear=$normalizedAcademicYearId isActive=${isActive?.toString() ?: "<any>"} limit=${limit.coerceAtLeast(1)} offset=${offset.coerceAtLeast(0)}"
        )
        return getRecordList<ClassSectionResponse>(
            url = url,
            authenticated = true
        )
    }

    suspend fun filterClassSections(
        request: ClassSectionFilterRequest,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<ClassSectionResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.CLASS_SECTIONS_FILTER_URL,
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog(
            "$TAG filterClassSections url=$url classId=${request.classId.orEmpty().ifBlank { "<blank>" }} sectionId=${request.sectionId.orEmpty().ifBlank { "<blank>" }} subjectCode=${request.subjectCode.orEmpty().ifBlank { "<blank>" }} status=${request.status.orEmpty().ifBlank { "<blank>" }}"
        )
        return postJson<RecordListResponse<ClassSectionResponse>>(
            url = url,
            body = request,
            authenticated = true,
            showBlockingLoader = false
        ).map { RecordListItems(it.items, it.count) }
    }

    suspend fun filterClassSectionsWithSubjects(
        request: ClassSectionFilterRequest,
        sortBy: String? = null,
        order: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        query: String? = null
    ): Result<List<ClassSectionResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.CLASS_SECTIONS_FILTER_WITH_SUBJECTS_URL,
            "q" to query?.trim()?.takeIf { it.isNotBlank() },
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString()
        )
        scLog(
            "$TAG filterClassSectionsWithSubjects url=$url q=${query.orEmpty().ifBlank { "<blank>" }} classId=${request.classId.orEmpty().ifBlank { "<blank>" }} sectionId=${request.sectionId.orEmpty().ifBlank { "<blank>" }} subjectCode=${request.subjectCode.orEmpty().ifBlank { "<blank>" }} status=${request.status.orEmpty().ifBlank { "<blank>" }}"
        )
        return postJson<RecordListResponse<ClassSectionResponse>>(
            url = url,
            body = request,
            authenticated = true,
            showBlockingLoader = false
        ).map { RecordListItems(it.items, it.count) }
    }

    suspend fun createClassSection(request: ClassSectionCreateRequest): Result<ClassSectionResponse> {
        val url = NetworkConstants.CLASS_SECTIONS_URL
        scLog(
            "$TAG createClassSection url=$url school=${request.schoolId.ifBlank { "<blank>" }} academicYear=${request.academicYearId.ifBlank { "<blank>" }} className=${request.className.ifBlank { "<blank>" }} sectionName=${request.sectionName.ifBlank { "<blank>" }}"
        )
        return postJson(
            url = url,
            body = request,
            authenticated = true
        )
    }

    suspend fun createClassSectionWithSubjects(
        schoolId: String,
        request: ClassSectionWithSubjectsCreateRequest
    ): Result<ClassSectionResponse> {
        val url = NetworkConstants.CLASS_SECTIONS_WITH_SUBJECTS_CREATE_URL
        scLog(
            "$TAG createClassSectionWithSubjects url=$url school=${schoolId.ifBlank { "<blank>" }} academicYear=${request.academicYearId.ifBlank { "<blank>" }} className=${request.className.ifBlank { "<blank>" }} sectionName=${request.sectionName.ifBlank { "<blank>" }} subjectCount=${request.subjectIds.size}"
        )
        return postJson(
            url = url,
            body = request,
            authenticated = true
        )
    }

    suspend fun updateClassSection(
        classSectionId: String,
        request: ClassSectionUpdateRequest
    ): Result<ClassSectionResponse> {
        val normalizedId = classSectionId.trim()
        val url = "${NetworkConstants.CLASS_SECTIONS_URL}${encodeQueryComponent(normalizedId)}"
        scLog("$TAG updateClassSection url=$url classSectionId=$normalizedId")
        return requestJson(
            url = url,
            method = HttpMethod.Put,
            authenticated = true,
            body = request
        )
    }

    suspend fun deleteClassSection(classSectionId: String): Result<Unit> {
        val normalizedId = classSectionId.trim()
        val url = "${NetworkConstants.CLASS_SECTIONS_URL}${encodeQueryComponent(normalizedId)}"
        scLog("$TAG deleteClassSection url=$url classSectionId=$normalizedId")
        return authenticatedMutation(url, HttpMethod.Delete)
    }

    suspend fun getClassSubjectLinks(
        classSectionId: String,
        isActive: Boolean? = null,
        limit: Int = 50,
        offset: Int = 0
    ): Result<List<ClassSubjectLinkResponse>> {
        val normalizedClassSectionId = classSectionId.trim()
        val url = buildUrlWithQuery(
            NetworkConstants.CLASS_SUBJECT_LINKS_URL,
            "class_section_id" to normalizedClassSectionId,
            "is_active" to isActive?.toString(),
            "limit" to limit.coerceAtLeast(1).toString(),
            "offset" to offset.coerceAtLeast(0).toString()
        )
        scLog(
            "$TAG getClassSubjectLinks url=$url classSectionId=$normalizedClassSectionId isActive=${isActive?.toString() ?: "<any>"} limit=${limit.coerceAtLeast(1)} offset=${offset.coerceAtLeast(0)}"
        )
        return getRecordList<ClassSubjectLinkResponse>(url = url, authenticated = true)
    }

    suspend fun getSubjectsTaughtInSection(
        classSectionId: String,
        limit: Int = 50,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<ClassSubjectLinkResponse>> {
        val normalizedClassSectionId = classSectionId.trim()
        require(normalizedClassSectionId.isNotBlank()) { "classSectionId must not be blank" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.SUBJECTS_LINKS_BY_SECTION_URL}/${encodePathSegment(normalizedClassSectionId)}",
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getSubjectsTaughtInSection url=$url classSectionId=$normalizedClassSectionId")
        return getRecordList(url = url, authenticated = true)
    }

    suspend fun createClassSubjectLink(
        request: ClassSubjectLinkCreateRequest
    ): Result<ClassSubjectLinkResponse> {
        val url = NetworkConstants.CLASS_SUBJECT_LINKS_URL
        scLog(
            "$TAG createClassSubjectLink url=$url classSectionId=${request.classSectionId.ifBlank { "<blank>" }} subjectId=${request.subjectId.ifBlank { "<blank>" }}"
        )
        return postJson(url = url, body = request, authenticated = true)
    }

    suspend fun updateClassSubjectLink(
        classSubjectLinkId: String,
        request: ClassSubjectLinkUpdateRequest
    ): Result<ClassSubjectLinkResponse> {
        val normalizedId = classSubjectLinkId.trim()
        val url = "${NetworkConstants.CLASS_SUBJECT_LINKS_URL}${encodeQueryComponent(normalizedId)}"
        scLog("$TAG updateClassSubjectLink url=$url classSubjectLinkId=$normalizedId")
        return requestJson(
            url = url,
            method = HttpMethod.Put,
            authenticated = true,
            body = request
        )
    }

    suspend fun deleteClassSubjectLink(classSubjectLinkId: String): Result<Unit> {
        val normalizedId = classSubjectLinkId.trim()
        val url = "${NetworkConstants.CLASS_SUBJECT_LINKS_URL}${encodeQueryComponent(normalizedId)}"
        scLog("$TAG deleteClassSubjectLink url=$url classSubjectLinkId=$normalizedId")
        return authenticatedMutation(url, HttpMethod.Delete)
    }

    suspend fun getStudents(
        schoolId: String,
        classSectionId: String? = null,
        query: String? = null,
        isActive: Boolean? = null,
        limit: Int = 20,
        offset: Int = 0
    ): Result<List<StudentResponse>> {
        val normalizedSchoolId = schoolId.trim()
        val normalizedClassSectionId = classSectionId?.trim()?.takeIf { it.isNotBlank() }
        val normalizedQuery = query?.trim()?.takeIf { it.isNotBlank() }
        val safeLimit = limit.coerceAtLeast(1)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            NetworkConstants.STUDENTS_URL,
            "school_id" to normalizedSchoolId,
            "class_section_id" to normalizedClassSectionId,
            "q" to normalizedQuery,
            "is_active" to isActive?.toString(),
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString()
        )
        scLog(
            "$TAG getStudents url=$url school=$normalizedSchoolId classSectionId=${normalizedClassSectionId ?: "<any>"} q=${normalizedQuery ?: "<blank>"} isActive=${isActive?.toString() ?: "<any>"} limit=$safeLimit offset=$safeOffset"
        )
        return getRecordList<StudentResponse>(
            url = url,
            authenticated = true
        )
    }

    suspend fun getStudentsWithClassSections(
        schoolId: String,
        classSectionId: String? = null,
        query: String? = null,
        isActive: Boolean? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<StudentListResponse>> {
        val normalizedSchoolId = schoolId.trim()
        val normalizedClassSectionId = classSectionId?.trim()?.takeIf { it.isNotBlank() }
        val normalizedQuery = query?.trim()?.takeIf { it.isNotBlank() }
        val safeLimit = limit.coerceAtLeast(1)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            NetworkConstants.STUDENTS_WITH_CLASS_SECTIONS_URL,
            "school_id" to normalizedSchoolId,
            "class_section_id" to normalizedClassSectionId,
            "q" to normalizedQuery,
            "is_active" to isActive?.toString(),
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog(
            "$TAG getStudentsWithClassSections url=$url school=$normalizedSchoolId classSectionId=${normalizedClassSectionId ?: "<any>"} q=${normalizedQuery ?: "<blank>"} isActive=${isActive?.toString() ?: "<any>"} limit=$safeLimit offset=$safeOffset"
        )
        return getRecordList<StudentListResponse>(
            url = url,
            authenticated = true
        )
    }

    suspend fun getStudentsWithParents(
        schoolId: String,
        query: String? = null,
        classSectionId: String? = null,
        isActive: Boolean? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<StudentListResponse>> {
        val normalizedSchoolId = schoolId.trim()
        val normalizedQuery = query?.trim()?.takeIf { it.isNotBlank() }
        val normalizedClassSectionId = classSectionId?.trim()?.takeIf { it.isNotBlank() }
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            NetworkConstants.STUDENTS_WITH_PARENTS_URL,
            "school_id" to normalizedSchoolId,
            "q" to normalizedQuery,
            "class_section_id" to normalizedClassSectionId,
            "is_active" to isActive?.toString(),
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog(
            "$TAG getStudentsWithParents url=$url school=$normalizedSchoolId q=${normalizedQuery ?: "<blank>"} isActive=${isActive?.toString() ?: "<any>"} limit=$safeLimit offset=$safeOffset"
        )
        return getRecordList<StudentListResponse>(url = url, authenticated = true)
    }

    suspend fun filterStudentsWithClassSections(
        schoolId: String,
        request: StudentFilterRequest,
        sortBy: String? = null,
        order: String? = null,
        limit: Int = 20,
        offset: Int = 0
    ): Result<List<StudentListResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.STUDENTS_FILTER_WITH_CLASS_SECTIONS_URL,
            "school_id" to schoolId.trim(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" },
            "limit" to limit.coerceAtLeast(1).toString(),
            "offset" to offset.coerceAtLeast(0).toString()
        )
        scLog(
            "$TAG filterStudentsWithClassSections url=$url classId=${request.classId.orEmpty().ifBlank { "<blank>" }} sectionId=${request.sectionId.orEmpty().ifBlank { "<blank>" }} query=${request.searchQuery.orEmpty().ifBlank { "<blank>" }} status=${request.status.orEmpty().ifBlank { "<blank>" }} subjectCount=${request.subjectCodes?.size ?: 0}"
        )
        return postJson<RecordListResponse<StudentListResponse>>(
            url = url,
            body = request,
            authenticated = true,
            showBlockingLoader = false
        )
            .map { RecordListItems(it.items, it.count) }
    }

    suspend fun createStudentWithSubjects(request: StudentWithSubjectEnrollmentsCreateRequest): Result<StudentResponse> =
        postJson(NetworkConstants.STUDENTS_WITH_SUBJECTS_URL, request, authenticated = true)

    suspend fun getStudent(studentId: String): Result<StudentResponse> =
        getJson("${NetworkConstants.STUDENTS_URL}${encodeQueryComponent(studentId.trim())}", authenticated = true)

    suspend fun updateStudent(studentId: String, request: StudentUpdateRequest): Result<StudentResponse> =
        requestJson(
            url = "${NetworkConstants.STUDENTS_URL}${encodeQueryComponent(studentId.trim())}",
            method = HttpMethod.Put,
            authenticated = true,
            body = request
        )

    suspend fun deleteStudent(studentId: String): Result<Unit> {
        val normalizedStudentId = studentId.trim()
        require(normalizedStudentId.isNotBlank()) { "studentId is required" }
        val url = "${NetworkConstants.STUDENTS_URL}${encodeQueryComponent(normalizedStudentId)}"
        scLog("$TAG deleteStudent url=$url studentId=$normalizedStudentId")
        return authenticatedMutation(
            url = url,
            method = HttpMethod.Delete
        )
    }

    suspend fun toggleStudentStatus(studentId: String, isActive: Boolean): Result<Unit> {
        val normalizedStudentId = studentId.trim()
        require(normalizedStudentId.isNotBlank()) { "studentId is required" }
        val url = "${NetworkConstants.STUDENTS_URL}${encodeQueryComponent(normalizedStudentId)}/toggle-status"
        scLog("$TAG toggleStudentStatus url=$url studentId=$normalizedStudentId isActive=$isActive")
        return authenticatedMutation(
            url = url,
            method = HttpMethod.Patch,
            body = StudentToggleStatusRequest(isActive = isActive)
        )
    }

    suspend fun getStudentSubjectEnrollments(studentId: String): Result<List<StudentSubjectEnrollmentResponse>> =
        getRecordList<StudentSubjectEnrollmentResponse>(
            buildUrlWithQuery(NetworkConstants.STUDENT_ENROLLMENTS_URL, "student_id" to studentId.trim(), "is_active" to "true", "limit" to "100", "offset" to "0"),
            authenticated = true
        )

    suspend fun createStudentSubjectEnrollment(request: StudentSubjectEnrollmentCreateRequest): Result<StudentSubjectEnrollmentResponse> =
        postJson(NetworkConstants.STUDENT_ENROLLMENTS_URL, request, authenticated = true)

    suspend fun deleteStudentSubjectEnrollment(enrollmentId: String): Result<Unit> =
        authenticatedMutation("${NetworkConstants.STUDENT_ENROLLMENTS_URL}${encodeQueryComponent(enrollmentId.trim())}", HttpMethod.Delete)

    suspend fun getParents(
        schoolId: String,
        query: String? = null,
        isActive: Boolean? = null,
        limit: Int = 100,
        offset: Int = 0
    ): Result<List<ParentListResponse>> {
        val normalizedSchoolId = schoolId.trim()
        val normalizedQuery = query?.trim()?.takeIf { it.isNotBlank() }
        val safeLimit = limit.coerceAtLeast(1)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            NetworkConstants.PARENTS_WITH_STUDENTS_URL,
            "school_id" to normalizedSchoolId,
            "q" to normalizedQuery,
            "is_active" to isActive?.toString(),
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString()
        )
        scLog(
            "$TAG getParents url=$url school=$normalizedSchoolId q=${normalizedQuery ?: "<blank>"} isActive=${isActive?.toString() ?: "<any>"} limit=$safeLimit offset=$safeOffset"
        )
        return getRecordList<ParentListResponse>(
            url = url,
            authenticated = true
        )
    }

    suspend fun getParentDashboard(): Result<ParentDashboardResponse> {
        val url = NetworkConstants.PARENT_DASHBOARD_URL
        scLog("$TAG getParentDashboard url=$url")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentProfileWithStudents(parentId: String): Result<ParentListResponse> {
        val normalizedParentId = parentId.trim()
        require(normalizedParentId.isNotBlank()) { "parentId must not be blank" }
        val url = "${NetworkConstants.PARENT_PROFILE_WITH_STUDENTS_URL}/${encodeQueryComponent(normalizedParentId)}"
        scLog("$TAG getParentProfileWithStudents url=$url parentId=$normalizedParentId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentWards(parentId: String): Result<List<StudentResponse>> {
        val normalizedParentId = parentId.trim()
        require(normalizedParentId.isNotBlank()) { "parentId must not be blank" }
        val url = "${NetworkConstants.PARENT_WARDS_URL}/${encodePathSegment(normalizedParentId)}/wards"
        scLog("$TAG getParentWards url=$url parentId=$normalizedParentId")
        return getRecordList<StudentResponse>(url = url, authenticated = true)
    }

    suspend fun getParentProfile(parentId: String): Result<ParentResponse> {
        val normalizedParentId = parentId.trim()
        require(normalizedParentId.isNotBlank()) { "parentId must not be blank" }
        val url = "${NetworkConstants.PARENTS_URL}${encodePathSegment(normalizedParentId)}"
        scLog("$TAG getParentProfile url=$url parentId=$normalizedParentId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getCalendarEvents(
        limit: Int = 20,
        offset: Int = 0,
        status: String? = null,
        eventType: String? = null,
        academicYearId: String? = null,
        fromDate: String? = null,
        toDate: String? = null,
        sortBy: String? = null,
        order: String? = null
    ): Result<RecordListResponse<CalendarEventPublicResponse>> = getJson(
        url = buildUrlWithQuery(
            NetworkConstants.CALENDAR_EVENTS_URL,
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "status" to status?.trim()?.takeIf { it.isNotBlank() },
            "event_type" to eventType?.trim()?.takeIf { it.isNotBlank() },
            "academic_year_id" to academicYearId?.trim()?.takeIf { it.isNotBlank() },
            "from_date" to fromDate?.trim()?.takeIf { it.isNotBlank() },
            "to_date" to toDate?.trim()?.takeIf { it.isNotBlank() },
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        ),
        authenticated = true
    )

    suspend fun createCalendarEvent(request: CalendarEventBulkCreateRequest): Result<List<CalendarEventPublicResponse>> =
        postJson(NetworkConstants.CALENDAR_EVENTS_URL, request, authenticated = true)

    suspend fun getCalendarEvent(eventId: String): Result<CalendarEventAdminResponse> =
        getJson(
            url = "${NetworkConstants.CALENDAR_EVENTS_URL}/${encodePathSegment(eventId.trim().also { require(it.isNotBlank()) { "eventId must not be blank" } })}",
            authenticated = true
        )

    suspend fun updateCalendarEvent(eventId: String, request: CalendarEventUpdateRequest): Result<CalendarEventAdminResponse> {
        val normalizedId = eventId.trim()
        require(normalizedId.isNotBlank()) { "eventId must not be blank" }
        return requestJson(
            url = "${NetworkConstants.CALENDAR_EVENTS_URL}/${encodePathSegment(normalizedId)}",
            method = HttpMethod.Put,
            authenticated = true,
            body = request
        )
    }

    suspend fun deleteCalendarEvent(eventId: String): Result<JsonElement> {
        val normalizedId = eventId.trim()
        require(normalizedId.isNotBlank()) { "eventId must not be blank" }
        return requestJson(
            url = "${NetworkConstants.CALENDAR_EVENTS_URL}/${encodePathSegment(normalizedId)}",
            method = HttpMethod.Delete,
            authenticated = true
        )
    }

    suspend fun validateCalendarImport(fileName: String, fileBytes: ByteArray): Result<CalendarImportValidationResponse> {
        val normalizedName = fileName.trim().ifBlank { "School_Calendar_Import.xlsx" }
        require(fileBytes.isNotEmpty()) { "Import file must not be empty" }
        scLog("$TAG validateCalendarImport fileName=$normalizedName bytes=${fileBytes.size}")
        return postMultipartFormData(
            url = NetworkConstants.CALENDAR_IMPORT_VALIDATE_URL,
            authenticated = true,
            reportGlobalError = false,
            body = MultiPartFormDataContent(formData {
                appendMultipartFile(
                    name = "file",
                    bytes = fileBytes,
                    fileName = normalizedName,
                    contentType = ContentType.parse("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                )
            })
        )
    }

    suspend fun commitCalendarImport(request: CalendarImportCommitRequest): Result<CalendarImportCommitResponse> =
        postJson(NetworkConstants.CALENDAR_IMPORT_COMMIT_URL, request, authenticated = true)

    suspend fun downloadCalendarImportTemplate(): Result<ByteArray> =
        downloadExcel(NetworkConstants.CALENDAR_IMPORT_TEMPLATE_URL, "School_Calendar_Import.xlsx")

    suspend fun downloadCalendarCurrentData(): Result<ByteArray> =
        downloadExcel(NetworkConstants.CALENDAR_IMPORT_DOWNLOAD_URL, "School_Calendar_Current_Data.xlsx")

    suspend fun getParentAttendanceDetail(studentId: String, absenceLimit: Int = 50): Result<JsonObject> {
        val normalizedStudentId = studentId.trim()
        require(normalizedStudentId.isNotBlank()) { "studentId must not be blank" }
        val url = buildUrlWithQuery(
            NetworkConstants.PARENT_ATTENDANCE_DETAIL_URL,
            "student_id" to normalizedStudentId,
            "absence_limit" to absenceLimit.coerceIn(1, 200).toString()
        )
        scLog("$TAG getParentAttendanceDetail url=$url studentId=$normalizedStudentId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentAttendanceCalendar(studentId: String, year: Int, month: Int): Result<JsonObject> {
        val normalizedStudentId = studentId.trim()
        require(normalizedStudentId.isNotBlank()) { "studentId must not be blank" }
        val url = buildUrlWithQuery(
            NetworkConstants.PARENT_ATTENDANCE_CALENDAR_URL,
            "student_id" to normalizedStudentId,
            "year" to year.coerceIn(2000, 2100).toString(),
            "month" to month.coerceIn(1, 12).toString()
        )
        scLog("$TAG getParentAttendanceCalendar url=$url studentId=$normalizedStudentId year=$year month=$month")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentHomework(
        studentId: String? = null,
        status: String? = null,
        search: String? = null,
        offset: Int = 0,
        limit: Int = 20,
        sortBy: String? = null,
        order: String? = null
    ): Result<JsonObject> {
        val url = buildUrlWithQuery(
            NetworkConstants.PARENT_HOMEWORK_URL,
            "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() },
            "note_status" to status?.trim()?.takeIf { it.isNotBlank() && !it.equals("All", true) },
            "q" to search?.trim()?.takeIf { it.isNotBlank() },
            "offset" to offset.coerceAtLeast(0).toString(),
            "limit" to limit.coerceIn(1, 100).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG getParentHomework studentId=${studentId?.ifBlank { "<any>" } ?: "<any>"} status=${status.orEmpty()} offset=${offset.coerceAtLeast(0)} limit=${limit.coerceIn(1, 100)} searchPresent=${!search.isNullOrBlank()} sortBy=${sortBy.orEmpty()} order=${order.orEmpty()}")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentHomeworkSummary(studentId: String): Result<JsonObject> {
        val url = buildUrlWithQuery(NetworkConstants.PARENT_HOMEWORK_DETAIL_URL, "student_id" to studentId.trim())
        scLog("$TAG getParentHomeworkSummary url=$url studentId=${studentId.trim()}")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentHomeworkById(homeworkId: String): Result<JsonObject> {
        val url = "${NetworkConstants.PARENT_HOMEWORK_ITEM_URL}/${encodeQueryComponent(homeworkId.trim())}"
        scLog("$TAG getParentHomeworkById url=$url homeworkId=${homeworkId.trim()}")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentNotices(
        studentId: String? = null,
        search: String? = null,
        status: String? = null,
        publishedFrom: String? = null,
        publishedTo: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<ParentNoticeListItemResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.PARENT_NOTICES_URL,
            "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() },
            "q" to search?.trim()?.takeIf { it.isNotBlank() },
            "status" to status?.trim()?.takeIf { it.isNotBlank() },
            "published_from" to publishedFrom?.trim()?.takeIf { it.isNotBlank() },
            "published_to" to publishedTo?.trim()?.takeIf { it.isNotBlank() },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getParentNotices url=$url")
        return getRecordList(url = url, authenticated = true)
    }

    suspend fun getParentNoticesSummary(studentId: String): Result<JsonObject> {
        val normalizedStudentId = studentId.trim()
        require(normalizedStudentId.isNotBlank()) { "studentId must not be blank" }
        val url = buildUrlWithQuery(NetworkConstants.PARENT_NOTICES_SUMMARY_URL, "student_id" to normalizedStudentId)
        scLog("$TAG getParentNoticesSummary url=$url studentId=$normalizedStudentId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentNoticeById(noticeId: String): Result<JsonObject> {
        val normalizedNoticeId = noticeId.trim()
        require(normalizedNoticeId.isNotBlank()) { "noticeId must not be blank" }
        val url = "${NetworkConstants.PARENT_NOTICE_ITEM_URL}/${encodeQueryComponent(normalizedNoticeId)}"
        scLog("$TAG getParentNoticeById url=$url noticeId=$normalizedNoticeId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentEvents(studentId: String? = null, limit: Int = 20): Result<JsonObject> {
        val url = buildUrlWithQuery(NetworkConstants.PARENT_EVENTS_URL, "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() }, "limit" to limit.coerceIn(1, 100).toString())
        scLog("$TAG getParentEvents url=$url")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentEventsPage(
        studentId: String? = null,
        query: String? = null,
        status: String? = null,
        publishedFrom: String? = null,
        publishedTo: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<ParentEventListItemResponse>> {
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            NetworkConstants.PARENT_EVENTS_URL,
            "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() },
            "q" to query?.trim()?.takeIf { it.isNotBlank() },
            "status" to status?.trim()?.uppercase()?.takeIf { it.isNotBlank() },
            "published_from" to publishedFrom?.trim()?.takeIf { it.isNotBlank() },
            "published_to" to publishedTo?.trim()?.takeIf { it.isNotBlank() },
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getParentEventsPage limit=$safeLimit offset=$safeOffset hasQuery=${!query.isNullOrBlank()} status=${status ?: "<any>"} sortBy=${sortBy ?: "<default>"} order=${order ?: "<default>"}")
        return getRecordList(url = url, authenticated = true)
    }

    suspend fun getParentEventById(eventId: String): Result<JsonObject> {
        val normalizedEventId = eventId.trim()
        require(normalizedEventId.isNotBlank()) { "eventId must not be blank" }
        val url = "${NetworkConstants.PARENT_EVENT_ITEM_URL}/${encodeQueryComponent(normalizedEventId)}"
        scLog("$TAG getParentEventById url=$url eventId=$normalizedEventId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentPortalNotes(
        studentId: String,
        status: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        search: String? = null,
        teacherId: String? = null,
        createdFrom: String? = null,
        createdTo: String? = null,
        sortBy: String? = null,
        order: String? = null
    ): Result<JsonObject> {
        val normalizedStudentId = studentId.trim()
        require(normalizedStudentId.isNotBlank()) { "studentId must not be blank" }
        val url = buildUrlWithQuery(NetworkConstants.PARENT_PORTAL_NOTES_URL,
            "student_id" to normalizedStudentId,
            "note_status" to status?.trim()?.takeIf { it.isNotBlank() && !it.equals("All", true) },
            "q" to search?.trim()?.takeIf(String::isNotBlank),
            "teacher_id" to teacherId?.trim()?.takeIf { it.isNotBlank() },
            "created_from" to createdFrom?.trim()?.takeIf(String::isNotBlank),
            "created_to" to createdTo?.trim()?.takeIf(String::isNotBlank),
            "sort_by" to sortBy?.trim()?.takeIf(String::isNotBlank),
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString())
        scLog("$TAG getParentPortalNotes studentId=$normalizedStudentId limit=${limit.coerceIn(1, 100)} offset=${offset.coerceAtLeast(0)} sortBy=${sortBy.orEmpty()} order=${order.orEmpty()}")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentPortalNotesSummary(studentId: String): Result<JsonObject> {
        val normalizedStudentId = studentId.trim()
        require(normalizedStudentId.isNotBlank()) { "studentId must not be blank" }
        val url = buildUrlWithQuery(NetworkConstants.PARENT_PORTAL_NOTES_SUMMARY_URL, "student_id" to normalizedStudentId)
        scLog("$TAG getParentPortalNotesSummary url=$url studentId=$normalizedStudentId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentPortalNoteDetail(parentNoteId: String, studentId: String): Result<JsonObject> {
        val id = parentNoteId.trim()
        val normalizedStudentId = studentId.trim()
        require(id.isNotBlank()) { "parentNoteId must not be blank" }
        require(normalizedStudentId.isNotBlank()) { "studentId must not be blank" }
        val url = buildUrlWithQuery("${NetworkConstants.PARENT_PORTAL_NOTES_URL}/${encodePathSegment(id)}", "student_id" to normalizedStudentId)
        scLog("$TAG getParentPortalNoteDetail parentNoteId=$id studentId=$normalizedStudentId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentExamResults(
        studentId: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        search: String? = null,
        sortBy: String? = null,
        order: String? = null
    ): Result<JsonObject> {
        val url = buildUrlWithQuery(
            NetworkConstants.PARENT_EXAM_RESULTS_URL,
            "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() },
            "q" to search?.trim()?.takeIf { it.isNotBlank() },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getParentExamResults studentId=${studentId?.trim()?.ifBlank { "<any>" } ?: "<any>"} limit=${limit.coerceIn(1, 100)} offset=${offset.coerceAtLeast(0)} sortBy=${sortBy.orEmpty()} order=${order.orEmpty()}")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentExamResultsSummary(studentId: String): Result<JsonObject> {
        val normalizedStudentId = studentId.trim()
        require(normalizedStudentId.isNotBlank()) { "studentId must not be blank" }
        val url = buildUrlWithQuery(NetworkConstants.PARENT_EXAM_RESULTS_SUMMARY_URL, "student_id" to normalizedStudentId)
        scLog("$TAG getParentExamResultsSummary url=$url studentId=$normalizedStudentId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentExamResultDetail(examId: String, studentId: String): Result<JsonObject> {
        val normalizedExamId = examId.trim()
        val normalizedStudentId = studentId.trim()
        require(normalizedExamId.isNotBlank()) { "examId must not be blank" }
        require(normalizedStudentId.isNotBlank()) { "studentId must not be blank" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.PARENT_EXAM_RESULTS_URL}/${encodePathSegment(normalizedExamId)}",
            "student_id" to normalizedStudentId
        )
        scLog("$TAG getParentExamResultDetail url=$url examId=$normalizedExamId studentId=$normalizedStudentId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun createParentPortalNoteReply(parentNoteId: String, request: ParentNoteReplyCreateRequest): Result<JsonObject> {
        val id = parentNoteId.trim()
        require(id.isNotBlank()) { "parentNoteId must not be blank" }
        require(request.message.trim().isNotBlank()) { "message must not be blank" }
        val url = "${NetworkConstants.PARENT_PORTAL_NOTES_URL}/${encodePathSegment(id)}/reply"
        scLog("$TAG createParentPortalNoteReply parentNoteId=$id attachmentCount=${request.attachmentFileIds.size}")
        return postJson(url = url, body = request, authenticated = true)
    }

    suspend fun filterParentsWithStudents(
        schoolId: String,
        request: ParentFilterRequest,
        sortBy: String? = null,
        order: String? = null,
        limit: Int = 20,
        offset: Int = 0
    ): Result<List<ParentListResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.PARENTS_FILTER_WITH_STUDENTS_URL,
            "school_id" to schoolId.trim(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString()
        )
        return postJson<RecordListResponse<ParentListResponse>>(
            url = url,
            body = request,
            authenticated = true,
            showBlockingLoader = false
        )
            .map { RecordListItems(it.items, it.count) }
    }

    suspend fun createParentsAndLink(
        request: StudentParentWrapperCreateRequest,
        currentUserId: String? = null
    ): Result<JsonObject> {
        val normalizedCurrentUserId = currentUserId?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.BULK_CREATE_PARENTS_AND_LINK_URL,
            "current_user_id" to normalizedCurrentUserId
        )
        scLog(
            "$TAG createParentsAndLink url=$url studentId=${request.studentId} hasSecondary=${request.secondaryParent != null}"
        )
        return postJson(
            url = url,
            body = request,
            authenticated = true
        )
    }

    suspend fun createParent(request: ParentCreateRequest, currentUserId: String? = null): Result<ParentResponse> {
        val url = buildUrlWithQuery(
            NetworkConstants.PARENTS_URL,
            "current_user_id" to currentUserId?.trim()?.takeIf { it.isNotBlank() }
        )
        return postJson(url = url, body = request, authenticated = true)
    }

    suspend fun createStudentParentLink(request: StudentParentLinkCreateRequest): Result<StudentParentLinkResponse> =
        postJson(NetworkConstants.STUDENT_PARENT_LINKS_URL, request, authenticated = true)

    suspend fun updateStudentParentLink(
        linkId: String,
        request: StudentParentLinkUpdateRequest
    ): Result<StudentParentLinkResponse> = requestJson(
        url = "${NetworkConstants.STUDENT_PARENT_LINKS_URL}${encodeQueryComponent(linkId.trim())}",
        method = HttpMethod.Put,
        authenticated = true,
        body = request
    )

    suspend fun toggleStudentParentLinkStatus(linkId: String, isActive: Boolean): Result<Unit> {
        val normalizedLinkId = linkId.trim()
        require(normalizedLinkId.isNotBlank()) { "linkId is required" }
        val url = "${NetworkConstants.STUDENT_PARENT_LINKS_URL}${encodeQueryComponent(normalizedLinkId)}/toggle-status"
        return authenticatedMutation(url, HttpMethod.Patch, body = StudentToggleStatusRequest(isActive = isActive))
    }

    suspend fun deleteStudentParentLink(linkId: String): Result<Unit> {
        val normalizedLinkId = linkId.trim()
        require(normalizedLinkId.isNotBlank()) { "linkId is required" }
        val url = "${NetworkConstants.STUDENT_PARENT_LINKS_URL}${encodeQueryComponent(normalizedLinkId)}"
        return authenticatedMutation(url, HttpMethod.Delete)
    }

    suspend fun updateParent(
        parentId: String,
        request: ParentUpdateRequest,
        currentUserId: String? = null
    ): Result<ParentResponse> {
        val url = buildUrlWithQuery(
            "${NetworkConstants.PARENTS_URL}${encodeQueryComponent(parentId.trim())}",
            "current_user_id" to optionalUuidQueryValue(currentUserId)
        )
        scLog("$TAG updateParent url=$url parentId=${parentId.trim()}")
        return requestJson(url = url, method = HttpMethod.Put, authenticated = true, body = request)
    }

    suspend fun getAcademicYearAnalytics(schoolId: String? = null): Result<AcademicYearAnalyticsResponse> {
        val normalizedSchoolId = schoolId?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.ACADEMIC_YEARS_ANALYTICS_URL,
            "school_id" to normalizedSchoolId
        )
        scLog("$TAG getAcademicYearAnalytics url=$url school=${normalizedSchoolId ?: "<any>"}")
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun getSchools(
        q: String? = null,
        isActive: Boolean? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<SchoolResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.SCHOOLS_URL,
            "q" to q,
            "is_active" to isActive?.toString(),
            "limit" to limit.toString(),
            "offset" to offset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getSchools url=$url")
        return getRecordList<SchoolResponse>(
            url = url,
            authenticated = true
        )
    }

    suspend fun getSchoolsWithStudentCounts(
        q: String? = null,
        isActive: Boolean? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<SchoolResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.SCHOOLS_WITH_STUDENT_COUNTS_URL,
            "q" to q,
            "is_active" to isActive?.toString(),
            "limit" to limit.toString(),
            "offset" to offset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getSchoolsWithStudentCounts url=$url")
        return getRecordList<SchoolResponse>(
            url = url,
            authenticated = true
        )
    }

    suspend fun getUsers(
        q: String? = null,
        schoolId: String? = null,
        roleIds: List<Int> = emptyList(),
        isActive: Boolean? = null,
        createdFrom: String? = null,
        createdTo: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<PlatformUsersResponse> {
        val normalizedRoleIds = roleIds.distinct().sorted()
        val url = buildUrlWithQuery(
            NetworkConstants.USERS_URL,
            "q" to q,
            "school_id" to schoolId,
            "role_ids" to normalizedRoleIds.takeIf { it.isNotEmpty() }?.joinToString(","),
            "is_active" to isActive?.toString(),
            "created_from" to createdFrom,
            "created_to" to createdTo,
            "limit" to limit.toString(),
            "offset" to offset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getUsers url=$url roleIds=${normalizedRoleIds.joinToString(",").ifBlank { "<any>" }}")
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun getUsersAnalytics(
        schoolId: String? = null,
        roleIds: List<Int> = emptyList()
    ): Result<SchoolUsersAnalyticsResponse> {
        val normalizedSchoolId = schoolId?.trim()?.takeIf { it.isNotBlank() }
        val normalizedRoleIds = roleIds.distinct().sorted()
        val url = buildUrlWithQuery(
            NetworkConstants.USERS_ANALYTICS_URL,
            "school_id" to normalizedSchoolId,
            "role_ids" to normalizedRoleIds.takeIf { it.isNotEmpty() }?.joinToString(",")
        )
        scLog(
            "$TAG getUsersAnalytics url=$url school=${normalizedSchoolId ?: "<any>"} " +
                "roleIds=${normalizedRoleIds.joinToString(",").ifBlank { "<any>" }}"
        )
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun getSchoolStaffs(
        schoolId: String,
        roleTitle: String? = null,
        query: String? = null,
        isActive: Boolean? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<SchoolStaffResponse>> {
        val normalizedSchoolId = schoolId.trim()
        val normalizedRoleTitle = roleTitle?.trim()?.takeIf { it.isNotBlank() }
        val normalizedQuery = query?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.SCHOOL_STAFF_URL,
            "school_id" to normalizedSchoolId,
            "role_title" to normalizedRoleTitle,
            "q" to normalizedQuery,
            "is_active" to isActive?.toString(),
            "limit" to limit.coerceAtLeast(1).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog(
            "$TAG getSchoolStaffs url=$url school=$normalizedSchoolId roleTitle=${normalizedRoleTitle ?: "<any>"} q=${normalizedQuery ?: "<blank>"} isActive=${isActive?.toString() ?: "<any>"} limit=${limit.coerceAtLeast(1)} offset=${offset.coerceAtLeast(0)}"
        )
        return getRecordList<SchoolStaffResponse>(
            url = url,
            authenticated = true
        )
    }

    suspend fun getSchoolTeachers(
        schoolId: String,
        isActive: Boolean? = true,
        limit: Int = 100,
        offset: Int = 0
    ): Result<List<SchoolStaffResponse>> {
        val normalizedSchoolId = schoolId.trim()
        if (normalizedSchoolId.isBlank()) return Result.failure(IllegalArgumentException("schoolId is required"))
        val url = buildUrlWithQuery(
            NetworkConstants.SCHOOL_TEACHERS_URL,
            "school_id" to normalizedSchoolId,
            "is_active" to isActive?.toString(),
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to "name",
            "order" to "asc"
        )
        scLog("$TAG getSchoolTeachers url=$url school=$normalizedSchoolId limit=${limit.coerceIn(1, 100)} offset=${offset.coerceAtLeast(0)}")
        return getRecordList(url = url, authenticated = true)
    }

    suspend fun getSchoolStaffsWithAssignments(
        schoolId: String,
        roleTitle: String? = null,
        query: String? = null,
        isActive: Boolean? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<SchoolStaffWithAssignmentsResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.SCHOOL_STAFF_WITH_ASSIGNMENTS_URL,
            "school_id" to schoolId.trim(),
            "role_title" to roleTitle?.trim()?.takeIf { it.isNotBlank() },
            "q" to query?.trim()?.takeIf { it.isNotBlank() },
            "is_active" to isActive?.toString(),
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getSchoolStaffsWithAssignments url=$url")
        return getRecordList(url = url, authenticated = true)
    }

    suspend fun getSchoolStaffProfile(
        staffId: String
    ): Result<SchoolStaffResponse> {
        val normalizedStaffId = staffId.trim()
        val url = "${NetworkConstants.SCHOOL_STAFF_URL}${encodeQueryComponent(normalizedStaffId)}"
        scLog("$TAG getSchoolStaffProfile url=$url staffId=$normalizedStaffId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getTeacherDashboardOverview(): Result<TeacherDashboardOverviewResponse> {
        scLog("$TAG getTeacherDashboardOverview url=${NetworkConstants.TEACHER_DASHBOARD_OVERVIEW_URL}")
        return getJson(
            url = NetworkConstants.TEACHER_DASHBOARD_OVERVIEW_URL,
            authenticated = true
        )
    }

    suspend fun getTeacherDashboardStatistics(): Result<TeacherStatisticsResponse> {
        scLog("$TAG getTeacherDashboardStatistics url=${NetworkConstants.TEACHER_DASHBOARD_STATISTICS_URL}")
        return getJson(
            url = NetworkConstants.TEACHER_DASHBOARD_STATISTICS_URL,
            authenticated = true
        )
    }

    suspend fun getTeacherDashboardStudents(
        query: String? = null,
        gender: String? = null,
        classSectionId: String? = null,
        limit: Int = 100,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<TeacherStudentListResponse> {
        scLog("$TAG getTeacherDashboardStudents url=${NetworkConstants.TEACHER_DASHBOARD_STUDENTS_URL}")
        val url = buildUrlWithQuery(
            NetworkConstants.TEACHER_DASHBOARD_STUDENTS_URL,
            "q" to query?.trim()?.takeIf { it.isNotBlank() },
            "gender" to gender?.trim()?.takeIf { it.isNotBlank() },
            "class_section_id" to classSectionId?.trim()?.takeIf { it.isNotBlank() },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun getTeacherStudentAttendanceStats(studentId: String): Result<TeacherStudentAttendanceStatsResponse> {
        val normalizedStudentId = studentId.trim()
        val url = "${NetworkConstants.TEACHER_STUDENT_ATTENDANCE_STATS_URL}/$normalizedStudentId/attendance-stats"
        scLog("$TAG getTeacherStudentAttendanceStats url=$url studentId=$normalizedStudentId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getTeacherStudentAttendanceRecords(
        studentId: String,
        limit: Int = 50,
        offset: Int = 0,
        fromDate: String? = null,
        toDate: String? = null,
        status: String? = null
    ): Result<TeacherStudentAttendanceRecordsResponse> {
        val normalizedStudentId = studentId.trim()
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            "${NetworkConstants.TEACHER_STUDENT_ATTENDANCE_RECORDS_URL}/$normalizedStudentId/attendance-records",
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString(),
            "from_date" to fromDate?.trim()?.takeIf { it.isNotBlank() },
            "to_date" to toDate?.trim()?.takeIf { it.isNotBlank() },
            "status" to status?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG getTeacherStudentAttendanceRecords url=$url studentId=$normalizedStudentId limit=$safeLimit offset=$safeOffset")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getTeacherStudents(
        classSectionId: String? = null,
        query: String? = null,
        isActive: Boolean? = true,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<StudentListResponse>> {
        val normalizedClassSectionId = classSectionId?.trim()?.takeIf { it.isNotBlank() }
        val normalizedQuery = query?.trim()?.takeIf { it.isNotBlank() }
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            NetworkConstants.TEACHER_MY_STUDENTS_URL,
            "class_section_id" to normalizedClassSectionId,
            "q" to normalizedQuery,
            "is_active" to isActive?.toString(),
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog(
            "$TAG getTeacherStudents url=$url classSectionId=${normalizedClassSectionId ?: "<any>"} " +
                "q=${normalizedQuery ?: "<blank>"} isActive=${isActive?.toString() ?: "<any>"} limit=$safeLimit offset=$safeOffset"
        )
        return getRecordList<StudentListResponse>(url = url, authenticated = true)
    }

    suspend fun getTeacherStudentDetail(studentId: String): Result<StudentListResponse> {
        val normalizedStudentId = studentId.trim()
        if (normalizedStudentId.isBlank()) return Result.failure(IllegalArgumentException("Student ID is required."))
        val url = "${NetworkConstants.TEACHER_MY_STUDENTS_URL}/$normalizedStudentId"
        scLog("$TAG getTeacherStudentDetail url=$url studentId=$normalizedStudentId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getAttendanceRecords(
        classSectionId: String? = null,
        studentId: String? = null,
        targetDate: String? = null,
        status: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<StudentAttendanceResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.ATTENDANCE_URL,
            "class_section_id" to classSectionId?.trim()?.takeIf { it.isNotBlank() },
            "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() },
            "target_date" to targetDate?.trim()?.takeIf { it.isNotBlank() },
            "status" to status?.trim()?.takeIf { it.isNotBlank() },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getAttendanceRecords url=$url")
        return getRecordList(url = url, authenticated = true)
    }

    suspend fun getQuickMarkData(classSectionId: String, attendanceDate: String): Result<QuickMarkDataResponse> {
        val normalizedClassSectionId = classSectionId.trim()
        val normalizedAttendanceDate = attendanceDate.trim()
        if (normalizedClassSectionId.isBlank() || normalizedAttendanceDate.isBlank()) {
            return Result.failure(IllegalArgumentException("Class and attendance date are required to load Quick Mark data."))
        }
        val url = buildUrlWithQuery(
            NetworkConstants.ATTENDANCE_QUICK_MARK_DATA_URL,
            "class_section_id" to normalizedClassSectionId,
            "attendance_date" to normalizedAttendanceDate
        )
        scLog("$TAG getQuickMarkData url=$url classSectionId=$normalizedClassSectionId attendanceDate=$normalizedAttendanceDate")
        return getJson(url = url, authenticated = true)
    }

    suspend fun quickMarkAttendance(request: QuickMarkRequest, recordedById: String? = null): Result<Unit> {
        val url = buildUrlWithQuery(
            NetworkConstants.ATTENDANCE_QUICK_MARK_URL,
            "recorded_by_id" to recordedById?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog(
            "$TAG quickMarkAttendance url=$url classId=${request.classId} " +
                "attendanceDate=${request.attendanceDate} exceptions=${request.exceptions.size}"
        )
        return authenticatedMutation(url = url, method = HttpMethod.Post, body = request)
    }

    suspend fun createAttendance(
        targetDate: String,
        request: AttendanceRecordRequest
    ): Result<StudentAttendanceResponse> {
        val normalizedDate = targetDate.trim()
        val url = buildUrlWithQuery(
            NetworkConstants.ATTENDANCE_URL,
            "target_date" to normalizedDate
        )
        scLog(
            "$TAG createAttendance url=$url studentId=${request.studentId} " +
                "classSectionId=${request.classSectionId} status=${request.status}"
        )
        return requestJson(
            url = url,
            method = HttpMethod.Post,
            authenticated = true,
            body = request
        )
    }

    suspend fun updateAttendance(
        attendanceId: String,
        request: AttendanceUpdateRequest,
        recordedById: String? = null
    ): Result<StudentAttendanceResponse> {
        val normalizedId = attendanceId.trim()
        if (normalizedId.isBlank()) return Result.failure(IllegalArgumentException("Attendance id is required."))
        val url = buildUrlWithQuery(
            "${NetworkConstants.ATTENDANCE_URL}${encodeQueryComponent(normalizedId)}",
            "recorded_by_id" to recordedById?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG updateAttendance url=$url attendanceId=$normalizedId status=${request.status}")
        return requestJson(url = url, method = HttpMethod.Put, authenticated = true, body = request)
    }

    suspend fun getAttendanceHistory(
        studentId: String,
        fromDate: String? = null,
        toDate: String? = null,
        status: String? = null,
        sortBy: String = "attendance_date",
        order: String = "desc",
        offset: Int = 0,
        limit: Int = 10
    ): Result<AttendanceHistoryResponse> {
        val normalizedStudentId = studentId.trim()
        if (normalizedStudentId.isBlank()) return Result.failure(IllegalArgumentException("Student id is required."))
        val url = buildUrlWithQuery(
            "${NetworkConstants.ATTENDANCE_HISTORY_URL}/${encodeQueryComponent(normalizedStudentId)}",
            "from_date" to fromDate?.trim()?.takeIf { it.isNotBlank() },
            "to_date" to toDate?.trim()?.takeIf { it.isNotBlank() },
            "status" to status?.trim()?.takeIf { it.isNotBlank() },
            "sort_by" to sortBy.trim().takeIf { it.isNotBlank() },
            "order" to order.trim().lowercase().takeIf { it == "asc" || it == "desc" },
            "offset" to offset.coerceAtLeast(0).toString(),
            "limit" to limit.coerceIn(1, 100).toString()
        )
        scLog("$TAG getAttendanceHistory url=$url studentId=$normalizedStudentId offset=${offset.coerceAtLeast(0)} limit=$limit")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getTeacherAttendanceInsights(
        startDate: String? = null,
        endDate: String? = null,
        band: String? = null,
        classSectionId: String? = null,
        page: Int = 1,
        limit: Int = 20,
        sortBy: String? = null,
        order: String? = null,
        query: String? = null,
        status: String? = null
    ): Result<TeacherAttendanceInsightsResponse> {
        val url = buildUrlWithQuery(
            NetworkConstants.TEACHER_ATTENDANCE_INSIGHTS_URL,
            "start_date" to startDate?.trim()?.takeIf { it.isNotBlank() },
            "end_date" to endDate?.trim()?.takeIf { it.isNotBlank() },
            "band" to band?.trim()?.takeIf { it.isNotBlank() },
            "class_section_id" to classSectionId?.trim()?.takeIf { it.isNotBlank() },
            "q" to query?.trim()?.takeIf { it.isNotBlank() },
            "attendance_status" to status?.trim()?.takeIf { it.isNotBlank() },
            "page" to page.coerceAtLeast(1).toString(),
            "limit" to limit.coerceIn(1, 100).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { (it == "asc" || it == "desc") && !sortBy.isNullOrBlank() }
        )
        scLog("$TAG getTeacherAttendanceInsights url=$url")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getSchoolAttendanceInsights(
        classSectionId: String? = null,
        band: String? = null,
        page: Int = 1,
        limit: Int = 20,
        sortBy: String? = null,
        order: String? = null,
        startDate: String? = null,
        endDate: String? = null,
        query: String? = null,
        status: String? = null
    ): Result<AttendanceInsightsResponse> {
        val url = buildUrlWithQuery(
            NetworkConstants.SCHOOL_ATTENDANCE_INSIGHTS_URL,
            "class_section_id" to classSectionId?.trim()?.takeIf { it.isNotBlank() },
            "band" to band?.trim()?.takeIf { it.isNotBlank() },
            "start_date" to startDate?.trim()?.takeIf { it.isNotBlank() },
            "end_date" to endDate?.trim()?.takeIf { it.isNotBlank() },
            "q" to query?.trim()?.takeIf { it.isNotBlank() },
            "status" to status?.trim()?.takeIf { it.isNotBlank() },
            "page" to page.coerceAtLeast(1).toString(),
            "limit" to limit.coerceIn(1, 100).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { (it == "asc" || it == "desc") && !sortBy.isNullOrBlank() }
        )
        scLog("$TAG getSchoolAttendanceInsights url=$url")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getTeacherAttendanceStatistics(
        startDate: String? = null,
        endDate: String? = null
    ): Result<TeacherAttendanceStatisticsResponse> {
        val url = buildUrlWithQuery(
            NetworkConstants.TEACHER_ATTENDANCE_STATISTICS_URL,
            "start_date" to startDate?.trim()?.takeIf { it.isNotBlank() },
            "end_date" to endDate?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG getTeacherAttendanceStatistics url=$url")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getHomework(
        search: String? = null,
        classId: String? = null,
        subjectId: String? = null,
        status: String? = null,
        period: String? = null,
        page: Int = 1,
        limit: Int = 20,
        sortBy: String? = null,
        order: String? = null
    ): Result<HomeworkListResponse> {
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = (page.coerceAtLeast(1) - 1) * safeLimit
        val url = buildUrlWithQuery(
            NetworkConstants.HOMEWORK_URL,
            "q" to search?.trim()?.takeIf { it.isNotBlank() },
            "class_id" to classId?.trim()?.takeIf { it.isNotBlank() },
            "subject_id" to subjectId?.trim()?.takeIf { it.isNotBlank() },
            "hw_status" to status?.trim()?.takeIf { it.isNotBlank() },
            "period" to period?.trim()?.takeIf { it.isNotBlank() && !it.equals("All", ignoreCase = true) },
            "offset" to safeOffset.toString(),
            "limit" to safeLimit.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG getHomework url=$url page=${page.coerceAtLeast(1)} offset=$safeOffset limit=$safeLimit")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getTeacherHomeworkStatistics(): Result<TeacherHomeworkStatisticsResponse> {
        scLog("$TAG getTeacherHomeworkStatistics url=${NetworkConstants.TEACHER_HOMEWORK_STATISTICS_URL}")
        return getJson(url = NetworkConstants.TEACHER_HOMEWORK_STATISTICS_URL, authenticated = true)
    }

    suspend fun getTeacherHomework(
        search: String? = null,
        classSectionId: String? = null,
        subjectId: String? = null,
        status: String? = null,
        offset: Int = 0,
        limit: Int = 20,
        sortBy: String? = null,
        order: String? = null
    ): Result<HomeworkListResponse> {
        val url = buildUrlWithQuery(
            NetworkConstants.TEACHER_HOMEWORK_URL,
            "q" to search?.trim()?.takeIf { it.isNotBlank() },
            "class_section_id" to classSectionId?.trim()?.takeIf { it.isNotBlank() },
            "subject_id" to subjectId?.trim()?.takeIf { it.isNotBlank() },
            "hw_status" to status?.trim()?.takeIf { it.isNotBlank() },
            "offset" to offset.coerceAtLeast(0).toString(),
            "limit" to limit.coerceIn(1, 100).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG getTeacherHomework classSectionId=${classSectionId.orEmpty()} subjectId=${subjectId.orEmpty()} status=${status.orEmpty()} offset=${offset.coerceAtLeast(0)} limit=${limit.coerceIn(1, 100)} searchPresent=${!search.isNullOrBlank()} sortBy=${sortBy.orEmpty()} order=${order.orEmpty()}")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getHomeworkById(homeworkId: String): Result<HomeworkResponse> {
        val normalizedId = homeworkId.trim()
        require(normalizedId.isNotBlank()) { "homeworkId must not be blank" }
        val url = "${NetworkConstants.HOMEWORK_URL}${encodeQueryComponent(normalizedId)}"
        scLog("$TAG getHomeworkById url=$url")
        return getJson(url = url, authenticated = true)
    }

    suspend fun createHomework(
        request: HomeworkCreateRequest,
        currentUserId: String? = null
    ): Result<HomeworkResponse> {
        val url = buildUrlWithQuery(
            NetworkConstants.HOMEWORK_URL,
            "current_user_id" to optionalUuidQueryValue(currentUserId)
        )
        scLog(
            "$TAG createHomework classSectionId=${request.classSectionId} " +
                "subjectId=${request.subjectId} attachmentCount=${request.attachmentFileIds.size}"
        )
        return postJson(url = url, body = request, authenticated = true)
    }

    suspend fun updateHomework(
        homeworkId: String,
        request: HomeworkUpdateRequest
    ): Result<HomeworkResponse> {
        val normalizedId = homeworkId.trim()
        require(normalizedId.isNotBlank()) { "homeworkId must not be blank" }
        scLog("$TAG updateHomework homeworkId=$normalizedId attachmentCount=${request.attachmentFileIds.orEmpty().size}")
        return requestJson(
            url = "${NetworkConstants.HOMEWORK_URL}$normalizedId",
            method = HttpMethod.Put,
            authenticated = true,
            body = request
        )
    }

    suspend fun deleteHomework(homeworkId: String): Result<Unit> {
        val normalizedId = homeworkId.trim()
        require(normalizedId.isNotBlank()) { "homeworkId must not be blank" }
        val url = "${NetworkConstants.HOMEWORK_URL}${encodePathSegment(normalizedId)}"
        scLog("$TAG deleteHomework homeworkId=$normalizedId")
        return authenticatedMutation(url, HttpMethod.Delete)
    }

    suspend fun closeHomework(homeworkId: String): Result<HomeworkResponse> {
        val normalizedId = homeworkId.trim()
        require(normalizedId.isNotBlank()) { "homeworkId must not be blank" }
        val url = "${NetworkConstants.HOMEWORK_URL}${encodePathSegment(normalizedId)}${NetworkConstants.HOMEWORK_CLOSE_SUFFIX}"
        scLog("$TAG closeHomework homeworkId=$normalizedId")
        return requestJson(url = url, method = HttpMethod.Patch, authenticated = true)
    }

    suspend fun sendHomeworkReminder(homeworkId: String): Result<Unit> {
        val normalizedId = homeworkId.trim()
        require(normalizedId.isNotBlank()) { "homeworkId must not be blank" }
        val url = "${NetworkConstants.HOMEWORK_URL}${encodePathSegment(normalizedId)}/send-reminder"
        scLog("$TAG sendHomeworkReminder homeworkId=$normalizedId")
        return authenticatedMutation(url, HttpMethod.Post)
    }

    suspend fun createExam(
        request: ExamCreateRequest
    ): Result<ExamResponse> {
        val url = NetworkConstants.EXAMS_URL
        scLog("$TAG createExam classSectionId=${request.classSectionId} subjectId=${request.subjectId} examId=${request.examId}")
        return postJson(url = url, body = request, authenticated = true)
    }

    suspend fun updateExam(
        examId: String,
        request: ExamUpdateRequest
    ): Result<ExamResponse> {
        val normalizedId = examId.trim()
        require(normalizedId.isNotBlank()) { "examId must not be blank" }
        val url = "${NetworkConstants.EXAMS_URL}${encodePathSegment(normalizedId)}"
        scLog("$TAG updateExam examId=$normalizedId")
        return requestJson(
            url = url,
            method = HttpMethod.Put,
            authenticated = true,
            body = request
        )
    }

    suspend fun deleteExam(examId: String): Result<Unit> {
        val normalizedId = examId.trim()
        require(normalizedId.isNotBlank()) { "examId must not be blank" }
        val url = "${NetworkConstants.EXAMS_URL}${encodePathSegment(normalizedId)}"
        scLog("$TAG deleteExam examId=$normalizedId")
        return authenticatedMutation(url, HttpMethod.Delete)
    }

    suspend fun getNotices(
        schoolId: String? = null,
        noticeId: String? = null,
        audience: String? = null,
        status: String? = null,
        publishedFrom: String? = null,
        publishedTo: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<NoticeResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.NOTICES_URL,
            "school_id" to schoolId?.trim()?.takeIf { it.isNotBlank() },
            "notice_id" to noticeId?.trim()?.takeIf { it.isNotBlank() },
            "audience" to audience?.trim()?.takeIf { it.isNotBlank() },
            "status" to status?.trim()?.takeIf { it.isNotBlank() },
            "published_from" to publishedFrom?.trim()?.takeIf { it.isNotBlank() },
            "published_to" to publishedTo?.trim()?.takeIf { it.isNotBlank() },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getNotices url=$url")
        return getRecordList<NoticeResponse>(url = url, authenticated = true)
    }

    suspend fun getTeacherNoticeStatistics(): Result<TeacherNoticeStatisticsResponse> {
        scLog("$TAG getTeacherNoticeStatistics url=${NetworkConstants.TEACHER_NOTICE_STATISTICS_URL}")
        return getJson(url = NetworkConstants.TEACHER_NOTICE_STATISTICS_URL, authenticated = true)
    }

    suspend fun getNotice(noticeId: String): Result<NoticeResponse> {
        val normalizedId = noticeId.trim()
        require(normalizedId.isNotBlank()) { "noticeId must not be blank" }
        val url = "${NetworkConstants.NOTICE_DETAIL_URL}/${encodePathSegment(normalizedId)}"
        scLog("$TAG getNotice url=$url")
        return getJson(url = url, authenticated = true)
    }

    suspend fun createNotice(
        request: NoticeCreateRequest,
        currentUserId: String? = null
    ): Result<NoticeResponse> {
        val url = buildUrlWithQuery(
            NetworkConstants.NOTICES_URL,
            "current_user_id" to currentUserId?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG createNotice schoolId=${request.schoolId} attachmentCount=${request.attachmentFileIds.size}")
        return postJson(url = url, body = request, authenticated = true)
    }

    suspend fun updateNotice(noticeId: String, request: NoticeUpdateRequest): Result<NoticeResponse> {
        val normalizedId = noticeId.trim()
        require(normalizedId.isNotBlank()) { "noticeId must not be blank" }
        val url = "${NetworkConstants.NOTICE_DETAIL_URL}/${encodePathSegment(normalizedId)}"
        scLog("$TAG updateNotice noticeId=$normalizedId")
        return requestJson(url = url, method = HttpMethod.Put, authenticated = true, body = request)
    }

    suspend fun deleteNotice(noticeId: String): Result<JsonObject> {
        val normalizedId = noticeId.trim()
        require(normalizedId.isNotBlank()) { "noticeId must not be blank" }
        val url = "${NetworkConstants.NOTICE_DETAIL_URL}/${encodePathSegment(normalizedId)}"
        scLog("$TAG deleteNotice noticeId=$normalizedId")
        return requestJson(url = url, method = HttpMethod.Delete, authenticated = true)
    }

    suspend fun getQuickAnnouncements(
        search: String? = null,
        status: String? = null,
        createdById: String? = null,
        period: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<QuickAnnouncementListResponse> {
        val url = buildUrlWithQuery(
            NetworkConstants.QUICK_ANNOUNCEMENTS_LIST_URL,
            "q" to search?.trim()?.takeIf { it.isNotBlank() },
            "status_filter" to status?.trim()?.takeIf { it.isNotBlank() },
            "created_by_id" to createdById?.trim()?.takeIf { it.isNotBlank() },
            "period" to period?.trim()?.takeIf { it.isNotBlank() },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getQuickAnnouncements url=$url")
        return getJson(url, authenticated = true)
    }

    suspend fun createQuickAnnouncement(request: QuickAnnouncementCreateRequest): Result<QuickAnnouncementResponse> =
        postJson(NetworkConstants.QUICK_ANNOUNCEMENTS_URL, request, authenticated = true)

    suspend fun getQuickAnnouncement(announcementId: String): Result<QuickAnnouncementResponse> {
        val id = announcementId.trim()
        require(id.isNotBlank()) { "announcementId must not be blank" }
        return getJson("${NetworkConstants.QUICK_ANNOUNCEMENTS_URL}${encodePathSegment(id)}", authenticated = true)
    }

    suspend fun updateQuickAnnouncement(announcementId: String, request: QuickAnnouncementUpdateRequest): Result<QuickAnnouncementResponse> {
        val id = announcementId.trim()
        require(id.isNotBlank()) { "announcementId must not be blank" }
        return requestJson("${NetworkConstants.QUICK_ANNOUNCEMENTS_URL}${encodePathSegment(id)}", HttpMethod.Put, true, request)
    }

    suspend fun deleteQuickAnnouncement(announcementId: String): Result<JsonObject> {
        val id = announcementId.trim()
        require(id.isNotBlank()) { "announcementId must not be blank" }
        return requestJson("${NetworkConstants.QUICK_ANNOUNCEMENTS_URL}${encodePathSegment(id)}", HttpMethod.Delete, true)
    }

    suspend fun duplicateQuickAnnouncement(announcementId: String): Result<QuickAnnouncementResponse> {
        val id = announcementId.trim()
        require(id.isNotBlank()) { "announcementId must not be blank" }
        return postJson("${NetworkConstants.QUICK_ANNOUNCEMENTS_URL}${encodePathSegment(id)}/duplicate", Unit, authenticated = true)
    }

    suspend fun endQuickAnnouncement(announcementId: String): Result<JsonObject> {
        val id = announcementId.trim()
        require(id.isNotBlank()) { "announcementId must not be blank" }
        return postJson("${NetworkConstants.QUICK_ANNOUNCEMENTS_URL}${encodePathSegment(id)}/end-now", Unit, authenticated = true)
    }

    suspend fun getParentNotes(
        schoolId: String? = null,
        studentId: String? = null,
        parentId: String? = null,
        limit: Int = 20,
        offset: Int = 0
    ): Result<List<ParentNoteResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.PARENT_NOTES_URL,
            "school_id" to schoolId?.trim()?.takeIf { it.isNotBlank() },
            "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() },
            "parent_id" to parentId?.trim()?.takeIf { it.isNotBlank() },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString()
        )
        scLog("$TAG getParentNotes url=$url")
        return getRecordList(url = url, authenticated = true)
    }

    suspend fun createParentNote(
        request: ParentNoteCreateRequest,
        currentUserId: String? = null
    ): Result<List<ParentNoteResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.PARENT_NOTES_URL,
            "current_user_id" to currentUserId?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG createParentNote schoolId=${request.schoolId} studentId=${request.studentId} attachmentCount=${request.attachmentFileIds.size}")
        return postJson(url = url, body = request, authenticated = true)
    }

    suspend fun getParentNote(parentNoteId: String): Result<ParentNoteResponse> {
        val normalizedId = parentNoteId.trim()
        require(normalizedId.isNotBlank()) { "parentNoteId must not be blank" }
        val url = "${NetworkConstants.PARENT_NOTES_URL}${encodePathSegment(normalizedId)}"
        scLog("$TAG getParentNote parentNoteId=$normalizedId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getParentNoteReplies(
        parentNoteId: String,
        limit: Int = 100,
        offset: Int = 0
    ): Result<List<ParentNoteReplyResponse>> {
        val normalizedId = parentNoteId.trim()
        require(normalizedId.isNotBlank()) { "parentNoteId must not be blank" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.PARENT_NOTES_URL}${encodePathSegment(normalizedId)}/replies",
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString()
        )
        scLog("$TAG getParentNoteReplies parentNoteId=$normalizedId")
        return getRecordList(url = url, authenticated = true)
    }

    suspend fun updateParentNote(
        parentNoteId: String,
        request: ParentNoteUpdateRequest,
        currentUserId: String? = null
    ): Result<ParentNoteResponse> {
        val normalizedId = parentNoteId.trim()
        require(normalizedId.isNotBlank()) { "parentNoteId must not be blank" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.PARENT_NOTES_URL}${encodePathSegment(normalizedId)}",
            "current_user_id" to currentUserId?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG updateParentNote parentNoteId=$normalizedId attachmentCount=${request.attachmentFileIds.size}")
        return requestJson(url = url, method = HttpMethod.Put, authenticated = true, body = request)
    }

    suspend fun deleteParentNote(parentNoteId: String): Result<Unit> {
        val normalizedId = parentNoteId.trim()
        require(normalizedId.isNotBlank()) { "parentNoteId must not be blank" }
        val url = "${NetworkConstants.PARENT_NOTES_URL}${encodePathSegment(normalizedId)}"
        scLog("$TAG deleteParentNote parentNoteId=$normalizedId")
        return requestJson(url = url, method = HttpMethod.Delete, authenticated = true)
    }

    suspend fun createParentNoteReply(
        parentNoteId: String,
        request: ParentNoteReplyCreateRequest,
        currentUserId: String? = null
    ): Result<ParentNoteReplyResponse> {
        val normalizedId = parentNoteId.trim()
        require(normalizedId.isNotBlank()) { "parentNoteId must not be blank" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.PARENT_NOTES_URL}${encodePathSegment(normalizedId)}/replies",
            "current_user_id" to currentUserId?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG createParentNoteReply parentNoteId=$normalizedId attachmentCount=${request.attachmentFileIds.size}")
        return postJson(url = url, body = request, authenticated = true)
    }

    suspend fun getTeacherParentNoteStatistics(): Result<TeacherParentNoteStatisticsResponse> {
        scLog("$TAG getTeacherParentNoteStatistics url=${NetworkConstants.TEACHER_PARENT_NOTE_STATISTICS_URL}")
        return getJson(url = NetworkConstants.TEACHER_PARENT_NOTE_STATISTICS_URL, authenticated = true)
    }

    suspend fun getTeacherParentNotes(
        search: String? = null,
        status: String? = null,
        classSectionId: String? = null,
        studentId: String? = null,
        page: Int = 1,
        limit: Int = 20,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<ParentNoteResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.TEACHER_PARENT_NOTES_URL,
            "q" to search?.trim()?.takeIf { it.isNotBlank() },
            "status" to status?.trim()?.takeIf { it.isNotBlank() },
            "class_section_id" to classSectionId?.trim()?.takeIf { it.isNotBlank() },
            "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() },
            "offset" to ((page.coerceAtLeast(1) - 1) * limit.coerceIn(1, 100)).toString(),
            "limit" to limit.coerceIn(1, 100).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getTeacherParentNotes url=$url page=${page.coerceAtLeast(1)} limit=${limit.coerceIn(1, 100)}")
        return getRecordList(url = url, authenticated = true)
    }

    suspend fun getEvents(
        schoolId: String? = null,
        upcoming: Boolean? = null,
        query: String? = null,
        eventId: String? = null,
        status: String? = null,
        audience: String? = null,
        publishedDate: String? = null,
        publishedDateFrom: String? = null,
        publishedDateTo: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<EventResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.EVENTS_URL,
            "school_id" to schoolId?.trim()?.takeIf { it.isNotBlank() },
            "upcoming" to upcoming?.toString(),
            "q" to query?.trim()?.takeIf { it.isNotBlank() },
            "event_id" to eventId?.trim()?.takeIf { it.isNotBlank() },
            "status" to status?.trim()?.takeIf { it.isNotBlank() },
            "audience" to audience?.trim()?.takeIf { it.isNotBlank() },
            "published_date" to publishedDate?.trim()?.takeIf { it.isNotBlank() },
            // Backend support is pending; keep custom range server-side when available.
            "period_start" to publishedDateFrom?.trim()?.takeIf { it.isNotBlank() },
            "period_end" to publishedDateTo?.trim()?.takeIf { it.isNotBlank() },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getEvents url=$url")
        return getRecordList(url = url, authenticated = true)
    }

    suspend fun getEvent(eventId: String): Result<EventResponse> {
        val normalizedId = eventId.trim()
        require(normalizedId.isNotBlank()) { "eventId must not be blank" }
        val url = "${NetworkConstants.EVENTS_URL}${encodePathSegment(normalizedId)}"
        scLog("$TAG getEvent url=$url")
        return getJson(url = url, authenticated = true)
    }

    suspend fun createEvent(request: EventCreateRequest, currentUserId: String? = null): Result<EventResponse> {
        val url = buildUrlWithQuery(
            NetworkConstants.EVENTS_URL,
            "current_user_id" to currentUserId?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG createEvent schoolId=${request.schoolId} attachmentCount=${request.attachmentFileIds.size}")
        return postJson(url = url, body = request, authenticated = true)
    }

    suspend fun updateEvent(eventId: String, request: EventUpdateRequest, currentUserId: String? = null): Result<EventResponse> {
        val normalizedId = eventId.trim()
        require(normalizedId.isNotBlank()) { "eventId must not be blank" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.EVENTS_URL}${encodePathSegment(normalizedId)}",
            "current_user_id" to currentUserId?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog("$TAG updateEvent eventId=$normalizedId")
        return requestJson(url = url, method = HttpMethod.Put, authenticated = true, body = request)
    }

    suspend fun deleteEvent(eventId: String): Result<JsonObject> {
        val normalizedId = eventId.trim()
        require(normalizedId.isNotBlank()) { "eventId must not be blank" }
        val url = "${NetworkConstants.EVENTS_URL}${encodePathSegment(normalizedId)}"
        scLog("$TAG deleteEvent eventId=$normalizedId")
        return requestJson(url = url, method = HttpMethod.Delete, authenticated = true)
    }

    suspend fun getTeacherEventStatistics(): Result<TeacherEventStatisticsResponse> {
        scLog("$TAG getTeacherEventStatistics url=${NetworkConstants.TEACHER_EVENT_STATISTICS_URL}")
        return getJson(url = NetworkConstants.TEACHER_EVENT_STATISTICS_URL, authenticated = true)
    }

    suspend fun getExams(
        classSectionId: String,
        subjectId: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<ExamResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.EXAMS_URL,
            "class_section_id" to classSectionId.trim().takeIf { it.isNotBlank() },
            "subject_id" to subjectId?.trim()?.takeIf { it.isNotBlank() },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getExams url=$url")
        return getRecordList(url = url, authenticated = true)
    }

    suspend fun getExam(examId: String): Result<ExamResponse> {
        val normalizedId = examId.trim()
        require(normalizedId.isNotBlank()) { "examId must not be blank" }
        val url = "${NetworkConstants.EXAMS_URL}${encodePathSegment(normalizedId)}"
        scLog("$TAG getExam url=$url examId=$normalizedId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getExamResults(examId: String): Result<ExamResultsListResponse> {
        val normalizedId = examId.trim()
        require(normalizedId.isNotBlank()) { "examId must not be blank" }
        val url = "${NetworkConstants.EXAM_RESULTS_URL}/${encodePathSegment(normalizedId)}/results"
        scLog("$TAG getExamResults url=$url examId=$normalizedId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getStudentExamResults(studentId: String, limit: Int = 50, offset: Int = 0): Result<StudentExamResultRecordsResponse> {
        val normalizedStudentId = studentId.trim()
        require(normalizedStudentId.isNotBlank()) { "studentId must not be blank" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.API_V1_BASE_URL}/exam-results/",
            "student_id" to normalizedStudentId,
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString()
        )
        scLog("$TAG getStudentExamResults url=$url studentId=$normalizedStudentId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getExamResultsSummary(examId: String): Result<ExamResultsSummaryResponse> {
        val normalizedId = examId.trim()
        require(normalizedId.isNotBlank()) { "examId must not be blank" }
        val url = "${NetworkConstants.EXAM_RESULT_SUMMARY_URL}/${encodePathSegment(normalizedId)}"
        scLog("$TAG getExamResultsSummary url=$url examId=$normalizedId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getExamInsights(examId: String): Result<ExamInsightsResponse> {
        val normalizedId = examId.trim()
        require(normalizedId.isNotBlank()) { "examId must not be blank" }
        val url = "${NetworkConstants.EXAM_INSIGHTS_URL}/${encodePathSegment(normalizedId)}/insights"
        scLog("$TAG getExamInsights url=$url examId=$normalizedId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun publishExamResults(examId: String): Result<ExamPublishResponse> {
        val normalizedId = examId.trim()
        require(normalizedId.isNotBlank()) { "examId must not be blank" }
        val url = "${NetworkConstants.EXAM_PUBLISH_URL}/${encodePathSegment(normalizedId)}/publish"
        scLog("$TAG publishExamResults url=$url examId=$normalizedId")
        return postJsonWithoutBody(url = url, authenticated = true)
    }

    suspend fun downloadExamImportTemplate(examId: String): Result<ByteArray> {
        val normalizedId = examId.trim()
        require(normalizedId.isNotBlank()) { "examId must not be blank" }
        return downloadExcel(
            url = "${NetworkConstants.EXAM_IMPORT_TEMPLATE_URL}/${encodePathSegment(normalizedId)}/import-template",
            fileName = "Exam_${normalizedId}_Import_Template.xlsx"
        )
    }

    suspend fun downloadExamResultsExport(examId: String): Result<ByteArray> {
        val normalizedId = examId.trim()
        require(normalizedId.isNotBlank()) { "examId must not be blank" }
        return downloadExcel(
            url = "${NetworkConstants.EXAM_RESULTS_EXPORT_URL}/${encodePathSegment(normalizedId)}/results/export",
            fileName = "Exam_${normalizedId}_Results.xlsx"
        )
    }

    suspend fun importExamResults(examId: String, fileName: String, fileBytes: ByteArray): Result<ExamImportResponse> {
        val normalizedId = examId.trim()
        require(normalizedId.isNotBlank()) { "examId must not be blank" }
        require(fileBytes.isNotEmpty()) { "Import file must not be empty" }
        val url = "${NetworkConstants.EXAM_IMPORT_TEMPLATE_URL}/${encodePathSegment(normalizedId)}/import-results"
        scLog("$TAG importExamResults url=$url examId=$normalizedId fileName=${fileName.ifBlank { "<blank>" }} bytes=${fileBytes.size}")
        return requestJson(
            url = url,
            method = HttpMethod.Post,
            authenticated = true,
            body = MultiPartFormDataContent(
                formData {
                    appendMultipartFile(
                        name = "import_file",
                        bytes = fileBytes,
                        fileName = fileName.ifBlank { "Exam_Results.xlsx" },
                        contentType = ContentType.parse("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                    )
                }
            )
        )
    }

    suspend fun bulkEnterExamResults(classSectionId: String, request: ExamResultBulkEntryRequest): Result<ExamResultBulkEntryResponse> {
        val normalizedId = classSectionId.trim()
        require(normalizedId.isNotBlank()) { "classSectionId must not be blank" }
        val url = "${NetworkConstants.EXAM_RESULT_BULK_ENTRY_URL}/${encodePathSegment(normalizedId)}/bulk-entry"
        scLog("$TAG bulkEnterExamResults url=$url examId=${request.examId} status=${request.status} students=${request.results.size}")
        val body = examResultRequestJson.encodeToJsonElement(request).jsonObject
        // Send the already encoded JSON as text. Passing JsonObject through
        // Ktor's generic Any body path makes it look for a JsonLiteral
        // serializer at runtime instead of using the Json configuration above.
        val encodedBody = TextContent(
            body.toString(),
            ContentType.Application.Json
        )
        return postJson(url = url, body = encodedBody, authenticated = true)
    }

    suspend fun getTeacherExamStatistics(): Result<TeacherExamStatisticsResponse> {
        scLog("$TAG getTeacherExamStatistics url=${NetworkConstants.TEACHER_EXAM_STATISTICS_URL}")
        return getJson(url = NetworkConstants.TEACHER_EXAM_STATISTICS_URL, authenticated = true)
    }

    suspend fun getTeacherExams(
        search: String? = null,
        status: String? = null,
        classSectionId: String? = null,
        pageIndex: Int = 0,
        pageSize: Int = 20,
        sortBy: String? = null,
        order: String? = null
    ): Result<TeacherExamListResponse> {
        val safePageSize = pageSize.coerceIn(1, 100)
        val url = buildUrlWithQuery(
            NetworkConstants.TEACHER_EXAMS_URL,
            "q" to search?.trim()?.takeIf { it.isNotBlank() },
            "exam_status" to status?.trim()?.takeIf { it.isNotBlank() },
            "class_section_id" to classSectionId?.trim()?.takeIf { it.isNotBlank() },
            "offset" to (pageIndex.coerceAtLeast(0) * safePageSize).toString(),
            "limit" to safePageSize.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getTeacherExams url=$url offset=${pageIndex.coerceAtLeast(0) * safePageSize} limit=$safePageSize")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getTeacherExamResults(
        search: String? = null,
        status: String? = null,
        classSectionId: String? = null,
        pageIndex: Int = 0,
        pageSize: Int = 20,
        sortBy: String? = null,
        order: String? = null
    ): Result<TeacherExamResultListResponse> {
        val safePageSize = pageSize.coerceIn(1, 100)
        val url = buildUrlWithQuery(
            NetworkConstants.TEACHER_EXAM_RESULTS_URL,
            "q" to search?.trim()?.takeIf { it.isNotBlank() },
            "exam_status" to status?.trim()?.takeIf { it.isNotBlank() },
            "class_section_id" to classSectionId?.trim()?.takeIf { it.isNotBlank() },
            "offset" to (pageIndex.coerceAtLeast(0) * safePageSize).toString(),
            "limit" to safePageSize.toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getTeacherExamResults url=$url page=${pageIndex.coerceAtLeast(0) + 1} offset=${pageIndex.coerceAtLeast(0) * safePageSize} limit=$safePageSize")
        return getJson(url = url, authenticated = true)
    }


    suspend fun filterSchoolStaffs(
        schoolId: String,
        request: SchoolStaffFilterRequest,
        sortBy: String? = null,
        order: String? = null,
        limit: Int = 20,
        offset: Int = 0
    ): Result<List<SchoolStaffResponse>> {
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = offset.coerceAtLeast(0)
        val url = buildUrlWithQuery(
            NetworkConstants.SCHOOL_STAFF_FILTER_URL,
            "school_id" to schoolId.trim(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" },
            "limit" to safeLimit.toString(),
            "offset" to safeOffset.toString()
        )
        return postJson<RecordListResponse<SchoolStaffResponse>>(
            url = url,
            body = request,
            authenticated = true,
            showBlockingLoader = false
        )
            .map { RecordListItems(it.items, it.count) }
    }

    suspend fun getSubjects(
        schoolId: String,
        category: String? = null,
        query: String? = null,
        isActive: Boolean? = null,
        limit: Int = 50,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<SubjectResponse>> {
        val normalizedSchoolId = schoolId.trim()
        val normalizedCategory = category?.trim()?.takeIf { it.isNotBlank() }
        val normalizedQuery = query?.trim()?.takeIf { it.isNotBlank() }
        // The current OpenAPI contract derives school scope from the
        // authenticated context; school_id is not a documented query field.
        val url = buildUrlWithQuery(
            NetworkConstants.SUBJECTS_URL,
            "category" to normalizedCategory,
            "q" to normalizedQuery,
            "is_active" to isActive?.toString(),
            "limit" to limit.coerceAtLeast(1).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog(
            "$TAG getSubjects url=$url school=$normalizedSchoolId category=${normalizedCategory ?: "<any>"} q=${normalizedQuery ?: "<blank>"} isActive=${isActive?.toString() ?: "<any>"} limit=${limit.coerceAtLeast(1)} offset=${offset.coerceAtLeast(0)}"
        )
        return getRecordList<SubjectResponse>(
            url = url,
            authenticated = true
        )
    }

    suspend fun filterSubjects(
        request: SubjectFilterRequest,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<List<SubjectResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.SUBJECTS_FILTER_URL,
            "limit" to limit.coerceAtLeast(1).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog(
            "$TAG filterSubjects url=$url subjectCode=${request.subjectCode?.ifBlank { "<blank>" } ?: "<blank>"} subjectName=${request.subjectName?.ifBlank { "<blank>" } ?: "<blank>"} category=${request.category?.ifBlank { "<blank>" } ?: "<blank>"} status=${request.status?.ifBlank { "<blank>" } ?: "<blank>"} limit=${limit.coerceAtLeast(1)} offset=${offset.coerceAtLeast(0)}"
        )
        return postJson<RecordListResponse<SubjectResponse>>(
            url = url,
            body = request,
            authenticated = true,
            showBlockingLoader = false
        ).map { RecordListItems(it.items, it.count) }
    }

    suspend fun getSubject(subjectId: String): Result<SubjectResponse> {
        val normalizedId = subjectId.trim()
        val url = "${NetworkConstants.SUBJECTS_URL}${encodeQueryComponent(normalizedId)}"
        scLog("$TAG getSubject url=$url subjectId=$normalizedId")
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun createSubject(request: SubjectCreateRequest): Result<SubjectResponse> {
        val url = NetworkConstants.SUBJECTS_URL
        scLog(
            "$TAG createSubject url=$url shortCode=${request.shortCode.ifBlank { "<blank>" }} name=${request.name.ifBlank { "<blank>" }}"
        )
        return postJson(
            url = url,
            body = request,
            authenticated = true
        )
    }

    suspend fun updateSubject(
        subjectId: String,
        request: SubjectUpdateRequest
    ): Result<SubjectResponse> {
        val normalizedId = subjectId.trim()
        val url = "${NetworkConstants.SUBJECTS_URL}${encodeQueryComponent(normalizedId)}"
        scLog(
            "$TAG updateSubject url=$url subjectId=$normalizedId shortCode=${request.shortCode ?: "<unchanged>"} name=${request.name ?: "<unchanged>"} isActive=${request.isActive?.toString() ?: "<unchanged>"}"
        )
        return requestJson(
            url = url,
            method = HttpMethod.Put,
            authenticated = true,
            body = request
        )
    }

    suspend fun deleteSubject(subjectId: String): Result<Unit> {
        val normalizedId = subjectId.trim()
        val url = "${NetworkConstants.SUBJECTS_URL}${encodeQueryComponent(normalizedId)}"
        scLog("$TAG deleteSubject url=$url subjectId=$normalizedId")
        return authenticatedMutation(
            url = url,
            method = HttpMethod.Delete
        )
    }

    suspend fun createSchoolStaff(request: SchoolStaffCreateRequest): Result<SchoolStaffResponse> {
        val url = NetworkConstants.SCHOOL_STAFF_URL
        scLog(
            "$TAG createSchoolStaff url=$url schoolId=${request.schoolId.ifBlank { "<blank>" }} employeeId=${request.employeeId.ifBlank { "<blank>" }} name=${request.name.ifBlank { "<blank>" }} authRole=${request.authRole.ifBlank { "<blank>" }}"
        )
        return postJson(
            url = url,
            body = request,
            authenticated = true
        )
    }

    suspend fun createSchoolStaffWithAssignments(
        request: AddStaffWithAssignmentsRequest,
        currentUserId: String? = null
    ): Result<SchoolStaffResponse> {
        val url = buildUrlWithQuery(
            NetworkConstants.SCHOOL_STAFF_WITH_ASSIGNMENTS_URL,
            "current_user_id" to optionalUuidQueryValue(currentUserId)
        )
        scLog(
            "$TAG createSchoolStaffWithAssignments url=$url schoolId=${request.schoolId.ifBlank { "<blank>" }} employeeId=${request.employeeId.ifBlank { "<blank>" }} assignments=${request.teachingAssignments?.size ?: 0}"
        )
        return postJson(
            url = url,
            body = request,
            authenticated = true
        )
    }

    suspend fun updateSchoolStaff(
        staffId: String,
        request: SchoolStaffUpdateRequest,
        currentUserId: String? = null
    ): Result<SchoolStaffResponse> {
        val normalizedStaffId = staffId.trim()
        val normalizedCurrentUserId = optionalUuidQueryValue(currentUserId)
        val url = buildUrlWithQuery(
            "${NetworkConstants.SCHOOL_STAFF_URL}${encodeQueryComponent(normalizedStaffId)}",
            "current_user_id" to normalizedCurrentUserId
        )
        scLog(
            "$TAG updateSchoolStaff url=$url staffId=$normalizedStaffId currentUserId=${normalizedCurrentUserId ?: "<blank>"} employeeId=${request.employeeId ?: "<unchanged>"} authRole=${request.authRole ?: "<unchanged>"}"
        )
        return requestJson(
            url = url,
            method = HttpMethod.Put,
            authenticated = true,
            body = request
        )
    }

    suspend fun getSchoolStaffWithAssignments(
        staffId: String
    ): Result<SchoolStaffWithAssignmentsResponse> {
        val normalizedStaffId = staffId.trim()
        val url = "${NetworkConstants.SCHOOL_STAFF_URL}${encodeQueryComponent(normalizedStaffId)}/with-assignments"
        scLog("$TAG getSchoolStaffWithAssignments url=$url staffId=$normalizedStaffId")
        return getJson(url = url, authenticated = true)
    }

    suspend fun updateSchoolStaffWithAssignments(
        staffId: String,
        request: UpdateStaffWithAssignmentsRequest,
        currentUserId: String? = null
    ): Result<SchoolStaffWithAssignmentsResponse> {
        val normalizedStaffId = staffId.trim()
        val url = buildUrlWithQuery(
            "${NetworkConstants.SCHOOL_STAFF_URL}${encodeQueryComponent(normalizedStaffId)}/with-assignments",
            "current_user_id" to currentUserId?.trim()?.takeIf { it.isNotBlank() }
        )
        scLog(
            "$TAG updateSchoolStaffWithAssignments url=$url staffId=$normalizedStaffId assignments=${request.teachingAssignments?.size ?: 0}"
        )
        return requestJson(url = url, method = HttpMethod.Put, authenticated = true, body = request)
    }

    suspend fun deleteSchoolStaff(staffId: String): Result<Unit> {
        val normalizedStaffId = staffId.trim()
        val url = "${NetworkConstants.SCHOOL_STAFF_URL}${encodeQueryComponent(normalizedStaffId)}"
        scLog("$TAG deleteSchoolStaff url=$url staffId=$normalizedStaffId")
        return authenticatedMutation(url, HttpMethod.Delete)
    }

    suspend fun getAppStaffAnalytics(): Result<ITUsersAnalyticsResponse> {
        val url = NetworkConstants.APP_STAFF_ANALYTICS_URL
        scLog("$TAG getAppStaffAnalytics url=$url")
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun updateAppStaff(
        staffId: String,
        request: AppStaffUpdateRequest,
        currentUserId: String? = null
    ): Result<AppStaffResponse> {
        val url = buildUrlWithQuery(
            "${NetworkConstants.APP_STAFF_URL}${encodePathSegment(staffId.trim())}",
            "current_user_id" to optionalUuidQueryValue(currentUserId)
        )
        scLog("$TAG updateAppStaff staffId=${staffId.trim()}")
        return requestJson(url = url, method = HttpMethod.Put, authenticated = true, body = request)
    }

    suspend fun toggleAppStaffStatus(staffId: String, isActive: Boolean): Result<Unit> {
        val normalizedStaffId = staffId.trim()
        val url = "${NetworkConstants.APP_STAFF_URL}${encodePathSegment(normalizedStaffId)}/toggle-status"
        scLog("$TAG toggleAppStaffStatus staffId=$normalizedStaffId isActive=$isActive")
        return authenticatedMutation(
            url = url,
            method = HttpMethod.Patch,
            body = UserToggleStatusRequest(isActive = isActive)
        )
    }

    suspend fun deleteAppStaff(staffId: String): Result<Unit> {
        val normalizedStaffId = staffId.trim()
        val url = "${NetworkConstants.APP_STAFF_URL}${encodePathSegment(normalizedStaffId)}"
        scLog("$TAG deleteAppStaff staffId=$normalizedStaffId")
        return authenticatedMutation(url = url, method = HttpMethod.Delete)
    }

    suspend fun getAppStaff(
        q: String? = null,
        roleIds: List<Int> = emptyList(),
        isActive: Boolean? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<PlatformUsersResponse> {
        val normalizedRoleIds = roleIds.distinct().sorted()
        val url = buildUrlWithQuery(
            NetworkConstants.APP_STAFF_URL,
            "q" to q?.trim()?.takeIf { it.isNotBlank() },
            "role_ids" to normalizedRoleIds.takeIf { it.isNotEmpty() }?.joinToString(","),
            "is_active" to isActive?.toString(),
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getAppStaff url=$url roleIds=${normalizedRoleIds.joinToString(",").ifBlank { "<any>" }}")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getUserProfileRaw(userId: String): Result<JsonObject> {
        val normalizedUserId = userId.trim()
        val url = "${NetworkConstants.USERS_URL}${encodeQueryComponent(normalizedUserId)}"
        scLog("$TAG getUserProfileRaw url=$url userId=$normalizedUserId")
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun createUser(request: UserCreateRequest): Result<Unit> {
        val url = NetworkConstants.USERS_URL
        scLog(
            "$TAG createUser url=$url fullName=${request.fullName.ifBlank { "<blank>" }} roleId=${request.roleId} schoolId=${request.schoolId.orEmpty().ifBlank { "<blank>" }}"
        )
        return authenticatedMutation(url, HttpMethod.Post, body = request)
    }

    suspend fun updateUser(userId: String, request: UserUpdateRequest): Result<Unit> {
        val normalizedUserId = userId.trim()
        val url = "${NetworkConstants.USERS_URL}${encodeQueryComponent(normalizedUserId)}"
        scLog("$TAG updateUser url=$url userId=$normalizedUserId")
        return authenticatedMutation(url, HttpMethod.Put, body = request)
    }

    suspend fun toggleUserStatus(userId: String, isActive: Boolean): Result<Unit> {
        val normalizedUserId = userId.trim()
        val url = "${NetworkConstants.API_V1_BASE_URL}/users/${encodeQueryComponent(normalizedUserId)}/toggle-status"
        scLog("$TAG toggleUserStatus url=$url userId=$normalizedUserId isActive=$isActive")
        return authenticatedMutation(url, HttpMethod.Patch, body = UserToggleStatusRequest(isActive = isActive))
    }

    suspend fun updateUserRoleAssignment(
        assignmentId: String,
        request: UserSchoolRoleUpdateRequest
    ): Result<Unit> {
        val normalizedAssignmentId = assignmentId.trim()
        val url = "${NetworkConstants.API_V1_BASE_URL}/user-roles/${encodeQueryComponent(normalizedAssignmentId)}"
        scLog("$TAG updateUserRoleAssignment url=$url assignmentId=$normalizedAssignmentId")
        return authenticatedMutation(url, HttpMethod.Put, body = request)
    }

    suspend fun deleteUser(userId: String): Result<Unit> {
        val normalizedUserId = userId.trim()
        val url = "${NetworkConstants.USERS_URL}${encodeQueryComponent(normalizedUserId)}"
        scLog("$TAG deleteUser url=$url userId=$normalizedUserId")
        return authenticatedMutation(url, HttpMethod.Delete)
    }

    suspend fun getRoles(
        schoolId: String? = null,
        includeGlobal: Boolean = true,
        limit: Int = 50,
        offset: Int = 0
    ): Result<List<RoleResponse>> {
        val url = buildString {
            append(NetworkConstants.ROLES_URL)
            val params = mutableListOf<String>()
            schoolId?.trim()?.takeIf { it.isNotBlank() }?.let {
                params.add("school_id=${encodeQueryComponent(it)}")
            }
            params.add("include_global=$includeGlobal")
            params.add("limit=$limit")
            params.add("offset=$offset")
            if (params.isNotEmpty()) {
                append('?')
                append(params.joinToString("&"))
            }
        }
        scLog("$TAG getRoles url=$url")
        return getRecordList<RoleResponse>(
            url = url,
            authenticated = true
        )
    }

    suspend fun getSchoolAdminRoles(
        limit: Int = 50,
        offset: Int = 0
    ): Result<List<RoleResponse>> {
        val safeLimit = limit.coerceIn(1, 100)
        val safeOffset = offset.coerceAtLeast(0)
        val url = "${NetworkConstants.SCHOOL_ADMIN_ROLES_URL}?limit=$safeLimit&offset=$safeOffset"
        scLog("$TAG getSchoolAdminRoles url=$url limit=$safeLimit offset=$safeOffset")
        return getRecordList<RoleResponse>(url = url, authenticated = true)
    }

    suspend fun getUserRoleAuthorizations(userId: String): Result<UserRoleAuthorizationsResponse> {
        val normalizedUserId = userId.trim()
        val url = buildUrlWithQuery(
            NetworkConstants.USER_ROLE_AUTHORIZATIONS_URL,
            "user_id" to normalizedUserId
        )
        scLog("$TAG getUserRoleAuthorizations url=$url user=$normalizedUserId")
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun updateUserRoleSelection(assignmentId: String): Result<Unit> {
        val normalizedAssignmentId = assignmentId.trim()
        val url = "${NetworkConstants.API_V1_BASE_URL}/user-roles/${encodeQueryComponent(normalizedAssignmentId)}/select-context"
        scLog("$TAG updateUserRoleSelection url=$url assignmentId=$normalizedAssignmentId")
        return authenticatedMutation(url, HttpMethod.Patch)
    }

    suspend fun getSchoolByCode(code: String): Result<SchoolResponse> {
        val normalizedCode = code.trim()
        val url = "${NetworkConstants.SCHOOLS_URL}${encodeQueryComponent(normalizedCode)}"
        scLog("$TAG getSchoolByCode url=$url")
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun createSchool(school: SchoolCreateRequest): Result<SchoolResponse> {
        val url = NetworkConstants.SCHOOLS_URL
        scLog(
            "$TAG createSchool url=$url name=${school.name.ifBlank { "<blank>" }} description=${if (school.schoolDescription.isNullOrBlank()) "<blank>" else "<provided>"}"
        )
        return postFormUrlEncoded(
            url = url,
            body = school.toFormData(),
            authenticated = true
        )
    }

    suspend fun uploadSchoolSetup(
        schoolCode: String,
        fileName: String,
        fileBytes: ByteArray,
        currentUserId: String? = null
    ): Result<BulkUploadResponse> {
        val normalizedSchoolCode = schoolCode.trim()
        val normalizedCurrentUserId = currentUserId?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.BULK_UPLOAD_SCHOOL_SETUP_URL,
            "school_code" to normalizedSchoolCode,
            "mode" to "save",
            "current_user_id" to normalizedCurrentUserId
        )
        scLog(
            "$TAG uploadSchoolSetup url=$url schoolCode=${normalizedSchoolCode.ifBlank { "<blank>" }} fileName=${fileName.ifBlank { "<blank>" }} bytes=${fileBytes.size}"
        )
        return requestJson(
            url = url,
            method = HttpMethod.Post,
            authenticated = true,
            body = MultiPartFormDataContent(
                formData {
                    appendMultipartFile(
                        name = "file",
                        bytes = fileBytes,
                        fileName = fileName.ifBlank { "School_Setup.xlsx" },
                        contentType = ContentType.parse("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                    )
                }
            )
        )
    }

    suspend fun validateSchoolSetup(
        schoolCode: String,
        fileName: String,
        fileBytes: ByteArray,
        currentUserId: String? = null
    ): Result<BulkUploadValidationResponse> {
        val normalizedSchoolCode = schoolCode.trim()
        val normalizedCurrentUserId = currentUserId?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.BULK_UPLOAD_SCHOOL_SETUP_URL,
            "school_code" to normalizedSchoolCode,
            "mode" to "validate",
            "current_user_id" to normalizedCurrentUserId
        )
        scLog(
            "$TAG validateSchoolSetup url=$url schoolCode=${normalizedSchoolCode.ifBlank { "<blank>" }} fileName=${fileName.ifBlank { "<blank>" }} bytes=${fileBytes.size}"
        )
        return requestJson(
            url = url,
            method = HttpMethod.Post,
            authenticated = true,
            body = MultiPartFormDataContent(
                formData {
                    appendMultipartFile(
                        name = "file",
                        bytes = fileBytes,
                        fileName = fileName.ifBlank { "School_Setup.xlsx" },
                        contentType = ContentType.parse("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                    )
                }
            )
        )
    }

    suspend fun uploadStudentEnrollment(
        schoolCode: String,
        fileName: String,
        fileBytes: ByteArray,
        currentUserId: String? = null,
        mode: String = "save"
    ): Result<StudentEnrollmentBulkResponse> {
        val normalizedSchoolCode = schoolCode.trim()
        val normalizedCurrentUserId = currentUserId?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.BULK_UPLOAD_STUDENT_ENROLLMENT_URL,
            "school_code" to normalizedSchoolCode,
            "mode" to mode,
            "current_user_id" to normalizedCurrentUserId
        )
        scLog(
            "$TAG uploadStudentEnrollment url=$url schoolCode=${normalizedSchoolCode.ifBlank { "<blank>" }} fileName=${fileName.ifBlank { "<blank>" }} bytes=${fileBytes.size}"
        )
        return requestJson(
            url = url,
            method = HttpMethod.Post,
            authenticated = true,
            body = MultiPartFormDataContent(
                formData {
                    appendMultipartFile(
                        name = "file",
                        bytes = fileBytes,
                        fileName = fileName.ifBlank { "Student_Enrollment.xlsx" },
                        contentType = ContentType.parse("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                    )
                }
            )
        )
    }

    suspend fun validateStudentEnrollment(
        schoolCode: String,
        fileName: String,
        fileBytes: ByteArray,
        currentUserId: String? = null
    ): Result<StudentEnrollmentValidationResponse> {
        val normalizedSchoolCode = schoolCode.trim()
        val normalizedCurrentUserId = currentUserId?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.BULK_UPLOAD_STUDENT_ENROLLMENT_URL,
            "school_code" to normalizedSchoolCode,
            "mode" to "validate",
            "current_user_id" to normalizedCurrentUserId
        )
        scLog("$TAG validateStudentEnrollment schoolCode=${normalizedSchoolCode.ifBlank { "<blank>" }} fileName=${fileName.ifBlank { "<blank>" }} bytes=${fileBytes.size}")
        return requestJson(
            url = url,
            method = HttpMethod.Post,
            authenticated = true,
            body = MultiPartFormDataContent(
                formData {
                    appendMultipartFile(
                        name = "file",
                        bytes = fileBytes,
                        fileName = fileName.ifBlank { "Student_Enrollment.xlsx" },
                        contentType = ContentType.parse("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                    )
                }
            )
        )
    }

    suspend fun downloadSchoolSetupTemplate(schoolCode: String? = null): Result<ByteArray> {
        val normalizedSchoolCode = schoolCode?.trim()?.takeIf { it.isNotBlank() }
        val url = normalizedSchoolCode?.let {
            buildUrlWithQuery(NetworkConstants.BULK_UPLOAD_SCHOOL_SETUP_DOWNLOAD_URL, "school_code" to it)
        } ?: NetworkConstants.BULK_UPLOAD_SCHOOL_SETUP_TEMPLATE_URL
        val fileName = if (normalizedSchoolCode == null) "School_Setup_Template.xlsx" else "School_Setup_Current_Data.xlsx"
        return downloadExcel(url, fileName)
    }

    suspend fun downloadStudentEnrollmentTemplate(schoolCode: String? = null): Result<ByteArray> {
        val normalizedSchoolCode = schoolCode?.trim()?.takeIf { it.isNotBlank() }
        val url = normalizedSchoolCode?.let {
            buildUrlWithQuery(NetworkConstants.BULK_UPLOAD_STUDENT_ENROLLMENT_DOWNLOAD_URL, "school_code" to it)
        } ?: NetworkConstants.BULK_UPLOAD_STUDENT_ENROLLMENT_TEMPLATE_URL
        val fileName = if (normalizedSchoolCode == null) "Student_Enrollment_Template.xlsx" else "Student_Enrollment_Current_Data.xlsx"
        return downloadExcel(url, fileName)
    }

    suspend fun getClassConversations(
        query: String? = null,
        classSectionId: String? = null,
        studentId: String? = null,
        dateFrom: String? = null,
        dateTo: String? = null,
        limit: Int = 20,
        offset: Int = 0,
        sortBy: String? = null,
        order: String? = null
    ): Result<RecordListResponse<ClassConversationListResponse>> {
        val url = buildUrlWithQuery(
            NetworkConstants.CONVERSATIONS_URL,
            "class_section_id" to classSectionId?.trim()?.takeIf { it.isNotBlank() },
            "student_id" to studentId?.trim()?.takeIf { it.isNotBlank() },
            "q" to query?.trim()?.takeIf { it.isNotBlank() },
            "date_from" to dateFrom?.trim()?.takeIf { it.isNotBlank() },
            "date_to" to dateTo?.trim()?.takeIf { it.isNotBlank() },
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString(),
            "sort_by" to sortBy?.trim()?.takeIf { it.isNotBlank() },
            "order" to order?.trim()?.lowercase()?.takeIf { it == "asc" || it == "desc" }
        )
        scLog("$TAG getClassConversations url=$url")
        return getJson(url = url, authenticated = true)
    }

    suspend fun createClassConversation(request: ClassConversationCreateRequest): Result<ClassConversationResponse> {
        require(request.title.trim().isNotBlank()) { "title must not be blank" }
        require(request.description.trim().isNotBlank()) { "description must not be blank" }
        return postJson(
            url = NetworkConstants.CONVERSATIONS_URL,
            body = request.copy(title = request.title.trim(), description = request.description.trim(), studentId = request.studentId?.trim()?.takeIf { it.isNotBlank() }),
            authenticated = true
        )
    }

    suspend fun updateClassConversation(conversationId: String, request: ClassConversationUpdateRequest, attachmentChanged: Boolean = false): Result<ClassConversationResponse> {
        val id = conversationId.trim()
        require(id.isNotBlank()) { "conversationId must not be blank" }
        require(!request.title.isNullOrBlank() || !request.description.isNullOrBlank()) { "conversation update must include title or description" }
        val url = "${NetworkConstants.CONVERSATIONS_URL}${encodePathSegment(id)}"
        scLog("$TAG updateClassConversation conversationId=$id")
        val normalized = request.copy(title = request.title?.trim()?.takeIf { it.isNotBlank() }, description = request.description?.trim()?.takeIf { it.isNotBlank() })
        val body = if (attachmentChanged) buildJsonObject {
            put("title", normalized.title ?: "")
            put("description", normalized.description ?: "")
            if (normalized.attachmentUrl == null) put("attachment_url", JsonNull) else put("attachment_url", normalized.attachmentUrl)
            if (normalized.attachmentFilename == null) put("attachment_filename", JsonNull) else put("attachment_filename", normalized.attachmentFilename)
            if (normalized.attachmentSizeBytes == null) put("attachment_size_bytes", JsonNull) else put("attachment_size_bytes", normalized.attachmentSizeBytes)
        } else normalized
        return requestJson(url = url, method = HttpMethod.Put, authenticated = true, body = body)
    }

    suspend fun getClassConversation(conversationId: String): Result<ClassConversationResponse> {
        val id = conversationId.trim()
        require(id.isNotBlank()) { "conversationId must not be blank" }
        val url = "${NetworkConstants.CONVERSATIONS_URL}${encodePathSegment(id)}"
        scLog("$TAG getClassConversation conversationId=$id")
        return getJson(url = url, authenticated = true)
    }

    suspend fun getClassConversationReplies(
        conversationId: String,
        limit: Int = 50,
        offset: Int = 0
    ): Result<RecordListResponse<ClassConversationReplyResponse>> {
        val id = conversationId.trim()
        require(id.isNotBlank()) { "conversationId must not be blank" }
        val url = buildUrlWithQuery(
            "${NetworkConstants.CONVERSATIONS_URL}${encodePathSegment(id)}/replies",
            "limit" to limit.coerceIn(1, 100).toString(),
            "offset" to offset.coerceAtLeast(0).toString()
        )
        scLog("$TAG getClassConversationReplies conversationId=$id")
        return getJson(url = url, authenticated = true)
    }

    suspend fun createClassConversationReply(
        conversationId: String,
        request: ClassConversationReplyCreateRequest
    ): Result<ClassConversationReplyResponse> {
        val id = conversationId.trim()
        require(id.isNotBlank()) { "conversationId must not be blank" }
        require(request.replyText.trim().isNotBlank()) { "replyText must not be blank" }
        val url = "${NetworkConstants.CONVERSATIONS_URL}${encodePathSegment(id)}/replies"
        scLog("$TAG createClassConversationReply conversationId=$id")
        return postJson(url = url, body = request.copy(replyText = request.replyText.trim()), authenticated = true)
    }

    suspend fun moderateClassConversation(
        conversationId: String,
        action: String,
        reason: String? = null
    ): Result<ClassConversationResponse> {
        val id = conversationId.trim()
        val normalizedAction = action.trim().uppercase()
        require(id.isNotBlank()) { "conversationId must not be blank" }
        require(normalizedAction in setOf("CLOSE", "REOPEN")) { "Unsupported conversation action" }
        val url = "${NetworkConstants.CONVERSATIONS_URL}${encodePathSegment(id)}/${normalizedAction.lowercase()}"
        scLog("$TAG moderateClassConversation conversationId=$id action=$normalizedAction")
        return requestJson(
            url = url,
            method = HttpMethod.Patch,
            authenticated = true,
            body = ClassConversationModerationActionRequest(normalizedAction, reason?.trim()?.takeIf { it.isNotBlank() })
        )
    }

    suspend fun deleteClassConversation(
        conversationId: String,
        reason: String? = null
    ): Result<Unit> {
        val id = conversationId.trim()
        require(id.isNotBlank()) { "conversationId must not be blank" }
        val url = "${NetworkConstants.CONVERSATIONS_URL}${encodePathSegment(id)}"
        scLog("$TAG deleteClassConversation conversationId=$id")
        return requestJson(
            url = url,
            method = HttpMethod.Delete,
            authenticated = true,
            body = ClassConversationModerationActionRequest("DELETE", reason?.trim()?.takeIf { it.isNotBlank() })
        )
    }

    suspend fun deleteClassConversationReply(
        conversationId: String,
        replyId: String,
        reason: String? = null
    ): Result<Unit> {
        val conversation = conversationId.trim()
        val reply = replyId.trim()
        require(conversation.isNotBlank()) { "conversationId must not be blank" }
        require(reply.isNotBlank()) { "replyId must not be blank" }
        val url = "${NetworkConstants.CONVERSATIONS_URL}${encodePathSegment(conversation)}/replies/${encodePathSegment(reply)}"
        scLog("$TAG deleteClassConversationReply conversationId=$conversation replyId=$reply")
        return requestJson(
            url = url,
            method = HttpMethod.Delete,
            authenticated = true,
            body = ClassConversationModerationActionRequest("DELETE", reason?.trim()?.takeIf { it.isNotBlank() })
        )
    }

    private suspend fun downloadExcel(url: String, fileName: String): Result<ByteArray> {
        scLog("$TAG downloadExcel url=$url fileName=$fileName")
        return downloadBytesInternal(url, fileName, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    }

    private suspend fun downloadBytesInternal(url: String, fileName: String, contentType: String = "application/octet-stream"): Result<ByteArray> {
        scLog("$TAG downloadBytes url=$url fileName=$fileName")
        return NetworkActivityTracker.track(showBlockingLoader = true) {
            try {
                val response = client.request(url) {
                    method = HttpMethod.Get
                    val authorization = TokenStore.getAuthorizationHeaderValue()
                    if (authorization.isNotBlank()) header(HttpHeaders.Authorization, authorization)
                }
                if (!response.status.isSuccess()) return@track response.failureResult()
                val bytes = response.body<ByteArray>()
                val responseFileName = response.headers[HttpHeaders.ContentDisposition]
                    ?.let { header ->
                        runCatching {
                            ContentDisposition.parse(header)
                                .parameter(ContentDisposition.Parameters.FileName)
                        }.getOrNull()
                    }
                    ?.let(::safeDownloadFileName)
                    ?.takeIf { it.isNotBlank() }
                    ?: fileName
                if (!downloadFile(responseFileName, bytes, contentType)) {
                    return@track Result.failure(IllegalStateException("File downloads are not supported on this platform."))
                }
                Result.success(bytes)
            } catch (throwable: Throwable) {
                AppErrorCenter.emit(throwable, source = TAG)
                Result.failure(throwable)
            }
        }
    }

    private suspend fun downloadBytes(url: String, body: Any, fileName: String, contentType: String = "application/octet-stream"): Result<ByteArray> {
        scLog("$TAG downloadBytes post url=$url fileName=$fileName")
        return NetworkActivityTracker.track(showBlockingLoader = true) {
            try {
                val response = client.request(url) {
                    method = HttpMethod.Post
                    val authorization = TokenStore.getAuthorizationHeaderValue()
                    if (authorization.isNotBlank()) header(HttpHeaders.Authorization, authorization)
                    header(HttpHeaders.ContentType, ContentType.Application.Json.toString())
                    setBody(body)
                }
                if (!response.status.isSuccess()) return@track response.failureResult()
                val bytes = response.body<ByteArray>()
                val responseFileName = response.headers[HttpHeaders.ContentDisposition]
                    ?.let { header ->
                        runCatching {
                            ContentDisposition.parse(header)
                                .parameter(ContentDisposition.Parameters.FileName)
                        }.getOrNull()
                    }
                    ?.let(::safeDownloadFileName)
                    ?.takeIf { it.isNotBlank() }
                    ?: fileName
                if (!downloadFile(responseFileName, bytes, contentType)) {
                    return@track Result.failure(IllegalStateException("File downloads are not supported on this platform."))
                }
                Result.success(bytes)
            } catch (throwable: Throwable) {
                AppErrorCenter.emit(throwable, source = TAG)
                Result.failure(throwable)
            }
        }
    }

    private fun safeDownloadFileName(candidate: String): String =
        candidate
            .substringAfterLast('/')
            .substringAfterLast('\\')
            .filterNot { it.code < 0x20 || it.code == 0x7f }
            .trim()

    suspend fun updateSchool(
        code: String,
        school: SchoolUpdateRequest,
        currentUserId: String = ""
    ): Result<SchoolResponse> {
        val normalizedCode = code.trim()
        val normalizedUserId = currentUserId.trim()
        val url = buildUrlWithQuery(
            "${NetworkConstants.SCHOOLS_URL}${encodeQueryComponent(normalizedCode)}",
            "current_user_id" to normalizedUserId
        )
        scLog(
            "$TAG updateSchool url=$url code=${normalizedCode.ifBlank { "<blank>" }} user=${normalizedUserId.ifBlank { "<blank>" }}"
        )
        return requestJson(
            url = url,
            method = HttpMethod.Put,
            authenticated = true,
            body = school.toFormData()
        )
    }

    suspend fun toggleSchoolStatus(
        code: String,
        isActive: Boolean
    ): Result<Unit> {
        val normalizedCode = code.trim()
        val url = buildString {
            append(NetworkConstants.SCHOOLS_URL)
            append(encodeQueryComponent(normalizedCode))
        }
        scLog(
            "$TAG toggleSchoolStatus url=$url code=${normalizedCode.ifBlank { "<blank>" }} isActive=$isActive"
        )
        return authenticatedMutation(
            url = buildUrlWithQuery(
                "$url/toggle-status",
                "current_user_id" to UserSessionStore.getUserId().trim()
            ),
            method = HttpMethod.Patch,
            body = SchoolToggleStatusRequest(isActive = isActive)
        )
    }

    suspend fun deleteSchool(code: String): Result<Unit> {
        val normalizedCode = code.trim()
        val url = buildUrlWithQuery(
            "${NetworkConstants.SCHOOLS_URL}${encodeQueryComponent(normalizedCode)}",
            "current_user_id" to UserSessionStore.getUserId().trim()
        )
        scLog(
            "$TAG deleteSchool url=$url code=${normalizedCode.ifBlank { "<blank>" }}"
        )
        return authenticatedMutation(
            url = url,
            method = HttpMethod.Delete
        )
    }

    suspend fun getDashboardStatistics(): Result<DashboardStatisticsResponse> {
        scLog("$TAG getDashboardStatistics url=${NetworkConstants.DASHBOARD_STATISTICS_URL}")
        return getJson(
            url = NetworkConstants.DASHBOARD_STATISTICS_URL,
            authenticated = true
        )
    }

    suspend fun getSchoolStatistics(schoolId: String? = null): Result<SchoolStatisticsResponse> {
        val normalizedSchoolId = schoolId?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.ANALYTICS_STATISTICS_URL,
            "school_id" to normalizedSchoolId
        )
        scLog("$TAG getSchoolStatistics url=$url school=${normalizedSchoolId ?: "<any>"}")
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun getEventsNoticesAnalytics(
        schoolId: String? = null,
        upcomingEventsLimit: Int = 5,
        recentNoticesLimit: Int = 5
    ): Result<EventsNoticesAnalyticsResponse> {
        val normalizedSchoolId = schoolId?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.EVENTS_NOTICES_ANALYTICS_URL,
            "school_id" to normalizedSchoolId,
            "upcoming_events_limit" to upcomingEventsLimit.coerceAtLeast(1).toString(),
            "recent_notices_limit" to recentNoticesLimit.coerceAtLeast(1).toString()
        )
        scLog("$TAG getEventsNoticesAnalytics url=$url school=${normalizedSchoolId ?: "<any>"}")
        return getJson(
            url = url,
            authenticated = true
        )
    }


    suspend fun getRecentActivities(limit: Int = 50): Result<RecentActivitiesResponse> {
        val url = "${NetworkConstants.RECENT_ACTIVITIES_URL}?limit=$limit"
        scLog("$TAG getRecentActivities url=$url")
        return getJson(
            url = url,
            authenticated = true
        )
    }

    suspend fun getSystemHealth(): Result<SystemHealthResponse> {
        scLog("$TAG getSystemHealth url=${NetworkConstants.SYSTEM_HEALTH_URL}")
        return getJson(
            url = NetworkConstants.SYSTEM_HEALTH_URL,
            authenticated = true
        )
    }

    suspend fun getSystemLookupCategories(): Result<List<String>> {
        scLog("$TAG getSystemLookupCategories url=${NetworkConstants.SYSTEM_LOOKUP_CATEGORIES_URL}")
        return getJson<RecordListResponse<String>>(
            url = NetworkConstants.SYSTEM_LOOKUP_CATEGORIES_URL,
            authenticated = false
        ).map { it.items }
    }

    suspend fun getSystemLookups(category: String? = null): Result<List<LookupItemResponse>> {
        val normalizedCategory = category?.trim()?.takeIf { it.isNotBlank() }
        val url = buildUrlWithQuery(
            NetworkConstants.SYSTEM_LOOKUPS_URL,
            "category" to normalizedCategory
        )
        scLog("$TAG getSystemLookups category=${normalizedCategory ?: "<all>"}")
        return getJson<RecordListResponse<LookupItemResponse>>(
            url = url,
            authenticated = false
        ).map { it.items }
    }

    suspend fun getSystemLookupsByCategory(category: String): Result<LookupCategoryResponse> {
        val normalizedCategory = category.trim()
        require(normalizedCategory.isNotBlank()) { "Lookup category must not be blank" }
        val url = "${NetworkConstants.SYSTEM_LOOKUPS_URL}${encodePathSegment(normalizedCategory)}"
        scLog("$TAG getSystemLookupsByCategory category=$normalizedCategory")
        return getJson(url = url, authenticated = false)
    }

    suspend fun generateUsageAdoptionReport(request: UsageAdoptionReportRequest): Result<UsageAdoptionReportResponse> {
        scLog("$TAG generateUsageAdoptionReport CALLED from=${request.fromDate} to=${request.toDate} role=${request.role}, url=${NetworkConstants.REPORTS_USAGE_ADOPTION_URL}, authenticated=true")
        val result = postJson<UsageAdoptionReportResponse>(NetworkConstants.REPORTS_USAGE_ADOPTION_URL, request, authenticated = true)
        scLog("$TAG generateUsageAdoptionReport result isSuccess=${result.isSuccess}")
        return result
    }

    suspend fun generateAttendanceReport(request: AttendanceReportRequest): Result<AttendanceReportResponse> =
        postJson(NetworkConstants.REPORTS_ATTENDANCE_URL, request, authenticated = true)

    suspend fun exportAttendanceReport(request: AttendanceReportRequest, format: String): Result<ByteArray> =
        exportStaffReport(
            NetworkConstants.REPORTS_ATTENDANCE_EXPORT_URL,
            request,
            "Attendance_Report",
            format
        )

    suspend fun generateAcademicPerformanceReport(
        request: AcademicPerformanceReportRequest
    ): Result<AcademicPerformanceReportResponse> =
        postJson(NetworkConstants.REPORTS_ACADEMIC_PERFORMANCE_URL, request, authenticated = true)

    suspend fun exportAcademicPerformanceReport(
        request: AcademicPerformanceReportRequest,
        format: String
    ): Result<ByteArray> =
        exportStaffReport(
            NetworkConstants.REPORTS_ACADEMIC_PERFORMANCE_EXPORT_URL,
            request,
            "Academic_Performance_Report",
            format
        )

    suspend fun generateCombinedPerformanceReport(
        request: CombinedPerformanceReportRequest
    ): Result<CombinedPerformanceReportResponse> =
        postJson(NetworkConstants.REPORTS_COMBINED_PERFORMANCE_URL, request, authenticated = true)

    suspend fun exportCombinedPerformanceReport(
        request: CombinedPerformanceReportRequest,
        format: String
    ): Result<ByteArray> =
        exportStaffReport(
            NetworkConstants.REPORTS_COMBINED_PERFORMANCE_EXPORT_URL,
            request,
            "Combined_Performance_Report",
            format
        )

    private suspend fun exportStaffReport(
        endpoint: String,
        request: Any,
        fileName: String,
        format: String
    ): Result<ByteArray> {
        val normalizedFormat = format.trim().lowercase()
        require(normalizedFormat in setOf("pdf", "excel")) { "Report format must be pdf or excel." }
        val url = buildUrlWithQuery(endpoint, "format" to normalizedFormat)
        val contentType = if (normalizedFormat == "pdf") {
            "application/pdf"
        } else {
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
        return downloadBytes(
            url = url,
            body = request,
            fileName = "$fileName.$normalizedFormat",
            contentType = contentType
        )
    }

    suspend fun exportUsageAdoptionReport(request: UsageAdoptionReportRequest, format: String): Result<ByteArray> {
        scLog("$TAG exportUsageAdoptionReport format=$format")
        val url = buildUrlWithQuery(NetworkConstants.REPORTS_USAGE_ADOPTION_EXPORT_URL, "format" to format)
        return downloadBytes(url, request, fileName = "Usage_Adoption_Report.$format")
    }

    private suspend inline fun <reified T> postJson(
        url: String,
        body: Any,
        authenticated: Boolean,
        showBlockingLoader: Boolean = true,
    ): Result<T> {
        return requestJson(
            url = url,
            method = HttpMethod.Post,
            authenticated = authenticated,
            body = body,
            showBlockingLoader = showBlockingLoader
        )
    }

    private suspend inline fun <reified T> postJsonWithoutBody(
        url: String,
        authenticated: Boolean,
    ): Result<T> {
        return requestJson(
            url = url,
            method = HttpMethod.Post,
            authenticated = authenticated
        )
    }

    private suspend inline fun <reified T> postMultipartFormData(
        url: String,
        body: MultiPartFormDataContent,
        authenticated: Boolean,
        reportGlobalError: Boolean = true,
    ): Result<T> {
        return requestJson(
            url = url,
            method = HttpMethod.Post,
            authenticated = authenticated,
            body = body,
            reportGlobalError = reportGlobalError
        )
    }

    private suspend inline fun <reified T> postFormUrlEncoded(
        url: String,
        body: FormDataContent,
        authenticated: Boolean,
    ): Result<T> = requestJson(
        url = url,
        method = HttpMethod.Post,
        authenticated = authenticated,
        body = body
    )

    suspend fun getPerformanceCategories(): Result<List<com.schoolconnect.app.datasource.network.response.PerformanceCategoryResponse>> {
        scLog("$TAG getPerformanceCategories")
        return getJson(NetworkConstants.REPORTS_PERFORMANCE_CATEGORIES_URL, authenticated = true)
    }

    private suspend inline fun <reified T> getJson(
        url: String,
        authenticated: Boolean,
    ): Result<T> {
        return requestJson(
            url = url,
            method = HttpMethod.Get,
            authenticated = authenticated
        )
    }

    private suspend inline fun <reified T> getRecordList(
        url: String,
        authenticated: Boolean,
    ): Result<List<T>> {
        return getJson<RecordListResponse<T>>(
            url = url,
            authenticated = authenticated
        ).map { RecordListItems(it.items, it.count) }
    }

    private suspend inline fun <reified T> requestJson(
        url: String,
        method: HttpMethod,
        authenticated: Boolean,
        body: Any? = null,
        showBlockingLoader: Boolean? = null,
        reportGlobalError: Boolean = true,
    ): Result<T> {
        // Normal GETs render through the feature's shimmer. Mutating requests
        // keep the blocking app-level loader for save/edit/delete operations.
        return NetworkActivityTracker.track(showBlockingLoader = showBlockingLoader ?: method != HttpMethod.Get) {
            try {
                val response = client.request(url) {
                    this.method = method
                    if (authenticated) {
                        val authorization = TokenStore.getAuthorizationHeaderValue()
                        if (authorization.isNotBlank()) {
                            header(HttpHeaders.Authorization, authorization)
                        }
                    }
                    if (body != null) {
                        if (body !is MultiPartFormDataContent && body !is FormDataContent) {
                            header(HttpHeaders.ContentType, ContentType.Application.Json.toString())
                        }
                        setBody(body)
                    }
                }
                response.toResult(reportGlobalError)
            } catch (throwable: Throwable) {
                // A superseded GET is cancelled intentionally when a user
                // changes Calendar filters, paging, or sorting. Let that
                // cancellation propagate instead of showing a false error.
                if (throwable is CancellationException) throw throwable
                val message = "Network error (no HTTP response received): ${throwable.message ?: throwable::class.simpleName.orEmpty()}"
                if (reportGlobalError) AppErrorCenter.emit(message = message, source = TAG)
                Result.failure(IllegalStateException(message, throwable))
            }
        }
    }

    private fun SchoolCreateRequest.toFormData(): FormDataContent {
        return FormDataContent(
            Parameters.build {
                id?.trim()?.takeIf { it.isNotBlank() }?.let { append("id", it) }
                append("name", name)
                append("board", board)
                append("school_type", schoolType)
                append("medium", medium)
                append("address_line1", addressLine1)
                addressLine2?.takeIf { it.isNotBlank() }?.let { append("address_line2", it) }
                append("city", city)
                append("district", district)
                append("state", state)
                append("country", country)
                append("pin_code", pinCode)
                append("school_phone", schoolPhone)
                append("school_email", schoolEmail)
                append("primary_contact_name", primaryContactName)
                append("primary_contact_phone", primaryContactPhone)
                append("primary_contact_email", primaryContactEmail)
                secondaryContactName?.takeIf { it.isNotBlank() }?.let { append("secondary_contact_name", it) }
                secondaryContactPhone?.takeIf { it.isNotBlank() }?.let { append("secondary_contact_phone", it) }
                secondaryContactEmail?.takeIf { it.isNotBlank() }?.let { append("secondary_contact_email", it) }
                schoolDescription?.takeIf { it.isNotBlank() }?.let { append("school_description", it) }
            }
        )
    }

    private fun SchoolUpdateRequest.toFormData(): FormDataContent {
        val fieldsToClear = clearFields
        return FormDataContent(
            Parameters.build {
                appendChangedString("name", name)
                appendChangedString("board", board)
                appendChangedString("school_type", schoolType)
                appendChangedString("medium", medium)
                appendChangedString("address_line1", addressLine1)
                appendChangedNullableString("address_line2", addressLine2, fieldsToClear)
                appendChangedString("city", city)
                appendChangedString("district", district)
                appendChangedString("state", state)
                appendChangedString("country", country)
                appendChangedString("pin_code", pinCode)
                appendChangedString("school_phone", schoolPhone)
                appendChangedString("school_email", schoolEmail)
                appendChangedString("primary_contact_name", primaryContactName)
                appendChangedString("primary_contact_phone", primaryContactPhone)
                appendChangedString("primary_contact_email", primaryContactEmail)
                appendChangedNullableString("secondary_contact_name", secondaryContactName, fieldsToClear)
                appendChangedNullableString("secondary_contact_phone", secondaryContactPhone, fieldsToClear)
                appendChangedNullableString("secondary_contact_email", secondaryContactEmail, fieldsToClear)
                appendChangedNullableString("school_description", schoolDescription, fieldsToClear)
                attachmentFileIds?.takeIf { it.isNotBlank() }?.let { append("attachment_file_ids", it) }
            }
        )
    }

    private fun FormBuilder.appendMultipartFile(
        name: String,
        bytes: ByteArray,
        fileName: String = "$name.bin",
        contentType: ContentType = ContentType.Application.OctetStream
    ) {
        append(
            key = name,
            value = bytes,
            headers = Headers.build {
                append(
                    HttpHeaders.ContentDisposition,
                    ContentDisposition.File.withParameter(ContentDisposition.Parameters.Name, name)
                        .withParameter(ContentDisposition.Parameters.FileName, fileName)
                        .toString()
                )
                append(HttpHeaders.ContentType, contentType.toString())
            }
        )
    }

    private fun ParametersBuilder.appendChangedString(name: String, value: String?) {
        value?.takeIf { it.isNotBlank() }?.let { append(name, it) }
    }

    private fun ParametersBuilder.appendChangedNullableString(name: String, value: String?, clearFields: Set<String>) {
        when {
            value == null && name in clearFields -> append(name, "")
            value != null -> append(name, value)
        }
    }

    private suspend fun authenticatedMutation(
        url: String,
        method: HttpMethod,
        body: Any? = null
    ): Result<Unit> {
        return NetworkActivityTracker.track {
            try {
                val response = client.request(url) {
                    this.method = method
                    val authorization = TokenStore.getAuthorizationHeaderValue()
                    if (authorization.isNotBlank()) {
                        header(HttpHeaders.Authorization, authorization)
                    }
                    if (body != null) {
                        if (body !is MultiPartFormDataContent) {
                            header(HttpHeaders.ContentType, ContentType.Application.Json.toString())
                        }
                        setBody(body)
                    }
                }
                if (response.status.isSuccess()) {
                    Result.success(Unit)
                } else {
                    response.failureResult()
                }
            } catch (throwable: Throwable) {
                AppErrorCenter.emit(throwable, source = TAG)
                Result.failure(throwable)
            }
        }
    }

    private suspend inline fun <reified T> HttpResponse.toResult(reportGlobalError: Boolean): Result<T> {
        return if (status.isSuccess()) {
            Result.success(body())
        } else {
            failureResult(reportGlobalError)
        }
    }

    private suspend inline fun <reified T> HttpResponse.failureResult(reportGlobalError: Boolean = true): Result<T> {
        val responseMessage = readErrorMessage()
        val message = "HTTP ${status.value} ${status.description}: $responseMessage"
        // The current backend uses 403 for requests whose bearer token is
        // missing/invalid in some environments, while other routes use 401.
        // Treat only the explicit authentication response as session expiry;
        // genuine permission denials must remain ordinary API failures.
        if (status == HttpStatusCode.Unauthorized ||
            (status == HttpStatusCode.Forbidden && message.contains("not authenticated", ignoreCase = true))
        ) {
            handleUnauthorized()
        }
        if (reportGlobalError) AppErrorCenter.emit(message = message, source = TAG)
        return Result.failure(IllegalStateException(message))
    }

    private suspend fun HttpResponse.readErrorMessage(): String {
        val fallback = "Request failed (${status.value})"
        val payload = runCatching { bodyAsText() }.getOrDefault("")
        if (payload.isBlank()) return fallback

        val parsed = runCatching { extractErrorMessage(json.parseToJsonElement(payload)) }.getOrNull()

        return when {
            parsed.isNullOrBlank() -> payload.take(240).ifBlank { fallback }
            else -> parsed
        }
    }

    private fun extractErrorMessage(element: JsonElement): String? = when (element) {
        is JsonObject -> sequenceOf("detail", "message", "error", "msg", "code")
            .mapNotNull { key -> element[key]?.let(::extractErrorMessage) }
            .firstOrNull { it.isNotBlank() }
        else -> element.jsonPrimitive.contentOrNull?.takeIf { it.isNotBlank() }
    }

    private fun handleUnauthorized() {
        scLog("$TAG unauthorized response detected; forcing login")
        AuthSessionCenter.emitSessionExpired()
        AppErrorCenter.emit(
            message = "Your session expired. Please sign in again.",
            source = TAG,
            dedupeKey = "session_expired_401"
        )
    }

    @Serializable
    private data class BackendErrorResponse(
        val detail: String = "",
        val message: String = "",
        val error: String = ""
    )
}
